import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useState, useEffect, useRef } from "react";
import {  IconButton, Modal, Box, Dialog, DialogActions,Checkbox,TextareaAutosize, DialogContent, DialogTitle, Grid, Card, CardContent, TextField } from '@mui/material';
import Table from 'react-bootstrap/Table';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Icon from "@mui/material/Icon";
import CloseIcon from '@mui/icons-material/Close';
import "layouts/style.css"
import {ButtonGroup,Button} from "react-bootstrap";
import { ToastContainer,toast } from "react-toastify";
import SoftTypography from "components/SoftTypography";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import Select from "react-select";
import { Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { fetchAllCustomer } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { submitCustomerApproval } from "assets/globalAPI/apiGlobal";
import { saveCustomerFormUploads } from "assets/globalAPI/apiGlobal";
import { saveCustomerPortalForm1 } from "assets/globalAPI/apiGlobal";
import { updateCustomerPortalForm1 } from "assets/globalAPI/apiGlobal";
import {Typography} from "@mui/material";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { fetchKDSCustomer } from "assets/globalAPI/apiGlobal";
import { fetchApproverDetails } from "assets/globalAPI/apiGlobal";
import { fetchAuditLog } from "assets/globalAPI/apiGlobal";
import { fetchCustomerByCode } from "assets/globalAPI/apiGlobal";
// import SoftButton from "components/SoftButton";

const Customerslist = () => {
    const toastId= useRef(null)
    const navigate= useNavigate();
    const [openModal, setOpenModal] = useState(false);
     const [selectedTab, setSelectedTab]= useState('details')
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogOpen2, setDialogOpen2] = useState(false);
    const [openApproverDialog, setOpenApproverDialog]= useState(false)
    const [isActive,setIsActive]= useState(false)
    const [searchLoader,setSearchLoader]= useState(false)
    // const [openDialog, setOpenDialog] = useState(false);
    const [isMsme, setIsMsme] = useState(false);
    const [isfssi, setIsFssi] = useState(false);
    const [isDept, setIsDept] = useState(false);
    const [isAcc, setIsAcc] = useState(false);
    const [isIT, setIsIT] = useState(false);
    const [isMDM, setIsMDM] = useState(false);
    const [isApprover1, setIsApprover1] = useState(false);
    const [approvalAllowed, setApprovalAllowed] = useState(false);
    const [editAllowed, setEditAllowed] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [approvalStatus, setApprovalStatus]= useState("");
    const [customerStatus,setCustomerStatus]= useState("")
      const [customerSearch,setCustomerSearch]= useState("");
      const [typingTimeout, setTypingTimeout] = useState(null);
      const typingTimeoutRef = useRef(null);
      const latestSearchRef = useRef("");
    const [selectedStatus,setSelectedStatus]= useState("pending");
    const [currentPage,setCurrentPage]= useState(1);
    const [totalPages,setTotalPages]= useState(1);
    const [customerDetails,setCustomerDetails]= useState([])
    const [approverData,setApproverData]= useState([]);
    const [lastApproverDetails,setLastApproverDetails]= useState([]);
    const [zData,setZData]= useState([])
    const [userID,setUserID]= useState("");
    const [userName,setUserName]= useState("");
    const [refId, setRefId]= useState("");
    const [searchTerm,setSearchTerm]= useState("");
    const [searchTerm2,setSearchTerm2]= useState("");
    const [keySelected,setKeySelected]= useState("");
    const [selectedField,setSelectedField]= useState("");
    const [enteredEmployeeCode,setEnteredEmployeeCode]= useState("");
    const [enteredEmployeeType,setEnteredEmployeeType]= useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [kdsdata,setKdsdata]= useState({});
    const [filteredZone,setFilteredZone]=useState([])
    const [allAuditLogs,setAllAuditLogs]= useState([])
    const [allApproveDetails,setAllApproveDetails]=useState([])
    const [openComment,setOpenComment]=useState('')
    const [openComment2,setOpenComment2]=useState('')
    const [comment,setComment]=useState('')
    const [dateSelected,setDateSelected]=useState(false);
    const [typedCode, setTypedCode] = useState("");
    const [stockistCode,setStockistCode]= useState("");
    const [stockistValue,setStockistValue]= useState("");

     const [formValues, setFormValues] = useState({
          reference_id: '',
          approved_by: userID,
          concern_super_stockist:'',
          registration_type: '',
          associated_to_sap_code:'',
          associated_to_sap_name: '', 
          sub_town_village_name: '', 
          working_town_village_name: '', 
          party_type: '', 
          date_of_association: '', 
          association_years: '',
          area_alloted: [
            { town_name: '', population: '', distance_from_godown: '',  }
          ],
          
          "targets": [
    {
      "name": "Biscuits",
      "months": {
        "Apr": "",
        "May": "",
        "Jun": "",
        "Jul": "",
        "Aug": "",
        "Sep": "",
        "Oct": "",
        "Nov": "",
        "Dec": "",
        "Jan": "",
        "Feb": "",
        "Mar": "",
      }
    },
    {
      "name": "Cookies",
      "months": {
        "Apr": "",
        "May": "",
        "Jun": "",
        "Jul": "",
        "Aug": "",
        "Sep": "",
        "Oct": "",
        "Nov": "",
        "Dec": "",
        "Jan": "",
        "Feb": "",
        "Mar": "",
      }
    },
    {
      "name": "Cakes",
      "months": {
        "Apr": "",
        "May": "",
        "Jun": "",
        "Jul": "",
        "Aug": "",
        "Sep": "",
        "Oct": "",
        "Nov": "",
        "Dec": "",
        "Jan": "",
        "Feb": "",
        "Mar": "",
      }
    },
    {
      "name": "Rusk",
      "months": {
        "Apr": "",
        "May": "",
        "Jun": "",
        "Jul": "",
        "Aug": "",
        "Sep": "",
        "Oct": "",
        "Nov": "",
        "Dec": "",
        "Jan": "",
        "Feb": "",
        "Mar": "",
      }
    },
    {
      "name": "Wafer",
      "months": {
        "Apr": "",
        "May": "",
        "Jun": "",
        "Jul": "",
        "Aug": "",
        "Sep": "",
        "Oct": "",
        "Nov": "",
        "Dec": "",
        "Jan": "",
        "Feb": "",
        "Mar": "",
      }
    }
  ]

        });

        const [formValues2,setFormValues2]= useState({
          reference_id:'',
          approved_by: userID,
          bp_grouping: '',
          customer_type: '',
          language: 'EN',
          type: '',
          search_term_1:'',
          search_term_2:'',
          company_code:'',
          customer_group:'',
          grouping_key:'',
          order_combination:'',
          reconciliation_account:'',
          account_assignment_group:'',
          account_statement:'',
          sort_key:'',
          payment_terms:'',
          payment_methods:'',
          sales_organisation:'',
          distribution_channel:'',
          division:'',
          sales_district:'',
          region:'',
          sub_group:'',
          zone:'',
          district_code:'',
          town_code:'',
          block_code:'',
          sales_office:'',
          sales_group:'',
          price_list:'',
          delivery_priority:'',
          order_probability:'',
          customer_pricing_procedure:'',
          shipping_conditions:'',
          bank_key:'',
          record_payment_history:'',
          withholding_tax_type:'',
          withholding_tax_type_2:'',
          withholding_tax_code:'',
          withholding_tax_code_2:'',
          withholding_tax_identification_number:'',
          withholding_tax_identification_number_2:'',
          withholding_agent:'',
          withholding_agent_2:'',
          withholding_start_date:'',
          withholding_start_date_2:'',
          tax_type_3:'',
          max_part_deliveries:'',
          incoterms:'',
          incoterms_location:'',
          fssiv: '',
          regdt: '',
          waers: 'INR',
          bscts: '',
          cknck: '',
          both0: '',
          rusk0: '',
          wafer: '',
          pan_stat: '',
          itr_stat: '',
        })

        const [formValues3,setFormValues3]= useState({
          reference_id: '',
          approved_by: userID,
          so_name:'',
          so_emp_code:'',
          so_email:'',
          so_date:'',
          asm_name:'',
          asm_emp_code:'',
          asm_email:'',
          asm_date:'',
          rsm_name:'',
          rsm_emp_code:'',
          rsm_email:'',
          rsm_date:'',
          zsm_name:'',
          zsm_emp_code:'',
          zsm_email:'',
          zsm_date:'',
          nsm_name:'',
          nsm_emp_code:'',
          nsm_email:'',
          nsm_date:'',
          dsm_name:'',
          dsm_emp_code:'',
          dsm_email:'',
          srm_name:'',
          srm_emp_code:'',
          srm_email:'',
        })

        useEffect(() => {
          setApprovalFields(prev => {
            const fieldName = "Customer Code";
        
            const alreadyExists = prev.final.some(f => f.name === fieldName);
        
            if (formValues2.bp_grouping == "GPEX" || formValues2.bp_grouping == "0002") {
              console.log("here is external>>>")
              if (alreadyExists) return prev;
        
              return {
                ...prev,
                final: [
                  ...prev.final,
                  {
                    name: fieldName,
                    type: "text",
                    block: "General Data",
                    value: formValues2.sap_code|| ""
                  }
                ]
              };
            } else {
              // Remove it if exists
              if (!alreadyExists) return prev;
        
              return {
                ...prev,
                final: prev.final.filter(f => f.name !== fieldName)
              };
            }
          });
        }, [formValues2.bp_grouping]);
        

        const [approvalFields, setApprovalFields] = useState({
          final: [
            { name: "BP Grouping", type: "dropdown", block: "General Data", apiKey: "bpgrp", option: [{}] },
            { name: "Language", type: "text", block: "General Data", value: "EN" },
            { name: "Search Term 1", type: "text", block: "General Data", value: "" },
            { name: "Search Term 2", type: "text", block: "General Data", value: "" },
            { name: "Company Code", type: "dropdown", block: "Company Code Data", apiKey: "compcode", option: [{}] },
            { name: "Customer Group", type: "dropdown", block: "Sales Data", apiKey: "custgrp", option: [{}] },
            { name: "Grouping Key", type: "text", block: "Company Code Data", value: "" },
            { name: "Order Combination", type: "checkbox", block: "Sales Data", value: false },
            { name: "Reconciliation account", type: "dropdown", block: "Company Code Data", apiKey: "reconacc", option: [{}] },
            { name: "Account Assignment Group", type: "dropdown", block: "Company Code Data", apiKey: "custacntgrp", option: [{}] },
            { name: "Account Statement", type: "text", block: "Company Code Data", value: "" },
            { name: "Sort key", type: "dropdown", block: "Company Code Data", apiKey: "sortkey", option: [{}] },
            { name: "Payment Terms", type: "dropdown", block: "Company Code Data", apiKey: "payterms", option: [{}] },
            { name: "Payment Methods", type: "dropdown", block: "Company Code Data", apiKey: "paymthd", option: [{}] },
            { name: "Sales Organisation", type: "dropdown", block: "Sales Data", apiKey: "salesorg", option: [{}] },
            { name: "Distribution Channel", type: "dropdown", block: "Sales Data", apiKey: "distchnl", option: [{}] },
            { name: "Division", type: "dropdown", block: "Sales Data", apiKey: "division", option: [{}] },
            { name: "Sales District", type: "dropdown", block: "Sales Data", apiKey: "saldstrct", option: [{}] },
            { name: "Sales Office", type: "dropdown", block: "Sales Data", apiKey: "saleofc", option: [{}] },
            { name: "Sales Group", type: "dropdown", block: "Sales Data", apiKey: "salegrpofcmap", option: [{}] },
            { name: "Price List", type: "dropdown", block: "Sales Data", apiKey: "priclst", option: [{}] },
            { name: "Delivery Priority", type: "dropdown", block: "Sales Data", apiKey: "dlvprty", option: [{}] },
            { name: "Region", type: "dropdown", block: "Sales Data", apiKey: "region", option: [{}] },
            { name: "Sub Group", type: "dropdown", block: "Sales Data", apiKey: "zgrp", option: [{}] },
            { name: "Zone", type: "dropdown", block: "Sales Data", apiKey: "zzone", option: [{}] },
            { name: "District Code", type: "text", block: "Sales Data", value: "" },
            { name: "Town Code", type: "text", block: "Sales Data", value: "" },
            { name: "Block Code", type: "text", block: "Sales Data", value: "" },
            { name: "Order Probability", type: "text", block: "Sales Data", value: "" },
            { name: "Currency", type: "dropdown", block: "Sales Data", apiKey: "ordrcurr", option: [{}] },
            { name: "Customer Pricing Procedure", type: "dropdown", block: "Sales Data", apiKey: "pricprcd", option: [{}] },
            { name: "Shipping Conditions", type: "dropdown", block: "Sales Data", apiKey: "shipcond", option: [{}] },
            { name: "Bank Key", type: "dropdown", block: "General Data", apiKey: "bankkey", option: [{}] },
            { name: "Record Payment History", type: "checkbox", block: "Company Code Data", value: false },
            { name: "Withholding Tax Type", type: "dropdown", block: "Company Code Data", apiKey: "witall", option: [{}] },
            { name: "Withholding Tax Code", type: "dropdown", block: "Company Code Data", apiKey: "witall", option: [{}] },
            { name: "Withholding Tax Identification Number", type: "text", block: "Company Code Data", value: "" },
            { name: "Withholding Agent", type: "checkbox", block: "Company Code Data", value: false },
            { name: "Withholding Start Date", type: "date", block: "Company Code Data", value: "" },
            { name: "Withholding Tax Type 2", type: "dropdown", block: "Company Code Data", apiKey: "witall", option: [{}] },
            { name: "Withholding Tax Code 2", type: "dropdown", block: "Company Code Data", apiKey: "witall", option: [{}] },
            { name: "Withholding Tax Identification Number 2", type: "text", block: "Company Code Data", value: "" },
            { name: "Withholding Agent 2", type: "checkbox", block: "Company Code Data", value: false },
            { name: "Withholding Start Date 2", type: "date", block: "Company Code Data", value: "" },
            { name: "Tax Type 3", type: "dropdown", block: "Company Code Data", apiKey: "taxtype", option: [{}] },
            { name: "Max Part Deliveries", type: "text", block: "Sales Data", value: "" },
            { name: "Incoterms", type: "dropdown", block: "Sales Data", apiKey: "incoterms", option: [{}] },
            { name: "Incoterms Location", type: "text", block: "Sales Data", value: "" },
            { name: "FSSAI Validity Date", type: "date2", block: "Sales Data", value: "" },
            { name: "Date Of Registration", type: "date2", block: "General Data", value: "" },
            { name: "PAN Status", type: "select", block: "General Data", option: [{ value: "OPERATIVE", label: "Operative" }, { value: "INOPERATIVE", label: "Inoperative" }], value:"" },
            { name: "ITR Start", type: "select", block: "General Data", option: [{ value: "YES", label: "Yes" }, { value: "NO", label: "No" }], value:"" },
            { name: "Biscuits", type: "checkbox", block: "General Data", value: false },
            { name: "Cakes", type: "checkbox", block: "General Data", value: false },
            { name: "Cookies", type: "checkbox", block: "General Data", value: false },
            { name: "Rusk", type: "checkbox", block: "General Data", value: false },
            { name: "Wafer", type: "checkbox", block: "General Data", value: false },
          ]
          
        });

        const fieldDisplayNames = {
          "reference_id": "Reference ID",
          "approval_status": "Approval Status",
          "approved_by": "Approved By",
          "firm_name": "Name of Firm",
          "firm_status": "Firm Status",
          "street": "Street",
          "co_name": "Company Name",
          "po_box": "P.O. Box",
          "city": "City",
          "district_name": "District Name",
          "block_tehsil": "Block/Tehsil",
          "main_town_village": "Main Town/Village",
          "post_office": "Post Office",
          "police_station": "Police Station",
          "state": "State*",
          "pin_code": "Pin Code*",
          "proprietor_name": "Proprietor Name",
          "proprietor_dob": "Proprietor Date of Birth",
          "proprietor_email": "Proprietor Email",
          "proprietor_mobile": "Proprietor Mobile",
          "pan": "PAN",
          "aadhaar": "Aadhaar",
          "cin": "CIN",
          "roc_status": "ROC Status",
          "inpln": "INPLN",
          "contact_person": "Contact Person",
          "contact_person_email": "Contact Person Email",
          "contact_person_mobile": "Contact Person Mobile",
          "mobile": "Mobile",
          "email": "Email",
          "contact_person_telephone": "Contact Person Telephone",
          "fssi_registration_status": "FSSAI Registration Status",
          "fssi_regn_no": "FSSAI Registration No.",
          "gstn": "GSTN",
          "tan": "TAN",
          "bank_name": "Bank Name",
          "bank_branch_name": "Bank Branch Name",
          "ifsc_code": "IFSC Code",
          "bank_account_number": "Bank Account Number",
          "undated_cheque_1": "Undated Cheque 1",
          "undated_cheque_2": "Undated Cheque 2",
          "undated_cheque_3": "Undated Cheque 3",
          "miscellaneous": "Miscellaneous",
          "companies": "Companies",
          "godown_area": "Godown Area",
          "godown_type": "Godown Type",
          "rcc_structure": "RCC Structure",
          "del_type_rickshaw": "Delivery Type (Rickshaw)",
          "del_type_van": "Delivery Type (Van)",
          "model_no_van": "Van Model No.",
          "customer_salesman_1": "Customer Salesman 1",
          "customer_salesman_no_1": "Customer Salesman No. 1",
          "customer_salesman_2": "Customer Salesman 2",
          "customer_salesman_no_2": "Customer Salesman No. 2",
          "customer_weekoff": "Customer Weekoff",
          "date_of_fillup": "Date of Fill-up",
          "approved_by": "Approved By",
          "bp_grouping": "BP Grouping",
          "language": "Language",
          "search_term_1": "Search Term 1",
          "search_term_2": "Search Term 2",
          "company_code": "Company Code",
          "customer_group": "Customer Group",
          "grouping_key": "Grouping Key",
          "order_combination": "Order Combination",
          "reconciliation_account": "Reconciliation Account",
          "account_assignment_group": "Account Assignment Group",
          "account_statement": "Account Statement",
          "sort_key": "Sort Key",
          "payment_terms": "Payment Terms",
          "payment_methods": "Payment Methods",
          "sales_organisation": "Sales Organisation",
          "distribution_channel": "Distribution Channel",
          "division": "Division",
          "sales_district": "Sales District",
          "region": "Region",
          "sub_group": "Sub Group",
          "zone": "Zone",
          "district_code": "District Code",
          "town_code": "Town Code",
          "block_code": "Block Code",
          "sales_office": "Sales Office",
          "sales_group": "Sales Group",
          "price_list": "Price List",
          "delivery_priority": "Delivery Priority",
          "order_probability": "Order Probability",
          "customer_pricing_procedure": "Customer Pricing Procedure",
          "shipping_conditions": "Shipping Conditions",
          "bank_key": "Bank Key",
          "record_payment_history": "Record Payment History",
          "withholding_tax_type": "Withholding Tax Type",
          "withholding_tax_type_2": "Withholding Tax Type 2",
          "withholding_tax_code": "Withholding Tax Code",
          "withholding_tax_code_2": "Withholding Tax Code 2",
          "withholding_tax_identification_number": "Withholding Tax Identification No.",
          "withholding_tax_identification_number_2": "Withholding Tax Identification No. 2",
          "withholding_agent": "Withholding Agent",
          "withholding_agent_2": "Withholding Agent 2",
          "withholding_start_date": "Withholding Start Date",
          "withholding_start_date_2": "Withholding Start Date 2",
          "tax_type_3": "Tax Type 3",
          "max_part_deliveries": "Max Part Deliveries",
          "incoterms": "Incoterms",
          "incoterms_location": "Incoterms Location",
          "fssiv": "FSSIV",
          "regdt": "Registration Date",
          "waers": "Currency",
          "bscts": "BSCTS",
          "cknck": "CKNCK",
          "both0": "Both0",
          "rusk0": "Rusk0",
          "wafer": "Wafer",
          "pan_stat": "PAN Status",
          "itr_stat": "ITR Status",
          
          "marketDetails": "Market Details",
          "registration_type": "Registration Type",
          "associated_to_sap_code": "Associated to SAP Code",
          "associated_to_sap_name": "Associated to SAP Name",
          "sub_town_village_name": "Sub Town/Village Name",
          "working_town_village_name": "Working Town/Village Name",
          "party_type": "Party Type",
          "date_of_association": "Date of Association",
          "association_years": "Association Years",
          
          "area_alloted": "Area Alloted",
          
          "so_name": "SO Name",
          "so_emp_code": "SO Employee Code",
          "so_email": "SO Email",
          "so_date": "SO Date",
          "asm_name": "ASM Name",
          "asm_emp_code": "ASM Employee Code",
          "asm_email": "ASM Email",
          "asm_date": "ASM Date",
          "rsm_name": "RSM Name",
          "rsm_emp_code": "RSM Employee Code",
          "rsm_email": "RSM Email",
          "rsm_date": "RSM Date",
          "zsm_name": "ZSM Name",
          "zsm_emp_code": "ZSM Employee Code",
          "zsm_email": "ZSM Email",
          "zsm_date": "ZSM Date",
          "nsm_name": "NSM Name",
          "nsm_emp_code": "NSM Employee Code",
          "nsm_email": "NSM Email",
          "nsm_date": "NSM Date",
          "dsm_name": "DSM Name",
          "dsm_emp_code": "DSM Employee Code",
          "dsm_email": "DSM Email",
          "srm_name": "SRM Name",
          "srm_emp_code": "SRM Employee Code",
          "srm_email": "SRM Email",
          
          "targets": "Targets"
        };

        const fieldDisplayNames2 = {
          "BP Grouping": "BP Grouping*",
          "Customer Code": "Customer Code",
          "Language": "Language*",
          "Search Term 1": "Search Term 1*",
          "Search Term 2": "Search Term 2",
          "Company Code": formValues2.customer_type!=="Sub Distributor" ?"Company Code*": "Company Code",
          "Customer Group":formValues2.customer_type!=="Sub Distributor" ?"Customer Group*": "Customer Group",
          "Grouping Key": "Grouping Key",
          "Order Combination": "Order Combination",
          "Reconciliation account": formValues2.customer_type!=="Sub Distributor" ?"Reconciliation account*":"Reconciliation account",
          "Account Assignment Group": "Account Assignment Group",
          "Account Statement": "Account Statement",
          "Sort key": "Sort Key",
          "Bank Key": "Bank Key",
          "Payment Terms": "Payment Terms",
          "Payment Methods": "Payment Methods",
          "Sales Organisation": "Sales Organisation*",
          "Distribution Channel": "Pin Distribution Channel*",
          "Division": "Division*",
          "Sales District": "Sales District",
          "Sales Office": formValues2.customer_type!=="Sub Distributor" ?"Sales Office*" :"Sales Office",
          "Sales Group": formValues2.customer_type!=="Sub Distributor" ?"Sales Group*":"Sales Group",
          "Price List": formValues2.customer_type!=="Sub Distributor" ?"Price List*":"Price List",
          "Shipping Conditions": formValues2.customer_type!=="Sub Distributor" ?"Shipping Conditions*": "Shipping Conditions",
          "Customer Pricing Procedure": formValues2.customer_type!=="Sub Distributor" ? "Customer Pricing Procedure*": "Customer Pricing Procedure",
          "Delivery Priority": "Delivery Priority",
          "Region": "Region*",
          "Sub Group": "Sub Group*",
          "Zone": "Zone*",
          "District Code": "District Code",
          "Town Code": "Town Code",
          "Block Code": "Block Code",
          "Order Probability": "Order Probability",
          "Currency": "Currency*",
          "Record Payment History": "Record Payment History",
         "Withholding Tax Type": formValues2.customer_type!=="Sub Distributor" ? "Withholding Tax Type*" : "Withholding Tax Type",
  "Withholding Tax Code": formValues2.customer_type!=="Sub Distributor" ? "Withholding Tax Code*" : "Withholding Tax Code",
  "Withholding Tax Identification Number": formValues2.customer_type!=="Sub Distributor" ? "Withholding Tax Identification Number*" : "Withholding Tax Identification Number",
  "Withholding Agent": formValues2.customer_type!=="Sub Distributor" ? "Withholding Agent*" : "Withholding Agent",
  "Withholding Start Date": formValues2.customer_type!=="Sub Distributor" ? "Withholding Start Date*" : "Withholding Start Date",
  "Withholding Tax Type 2": formValues2.customer_type!=="Sub Distributor" ? "Withholding Tax Type 2*" : "Withholding Tax Type 2",
  "Withholding Tax Code 2": "Withholding Tax Code 2", // no asterisk regardless
  "Withholding Tax Identification Number 2": formValues2.customer_type!=="Sub Distributor" ? "Withholding Tax Identification Number 2*" : "Withholding Tax Identification Number 2",
  "Withholding Agent 2": formValues2.customer_type!=="Sub Distributor" ? "Withholding Agent 2*" : "Withholding Agent 2",
  "Withholding Start Date 2": formValues2.customer_type!=="Sub Distributor" ? "Withholding Start Date 2*" : "Withholding Start Date 2",
          "Tax Type 3":formValues2.customer_type!=="Sub Distributor"? "Tax Type 3*": "Tax Type 3",
          "Max Part Deliveries": "Max Part Deliveries",
          "Incoterms": "Incoterms",
          "Incoterms Location": "Incoterms Location",
          "FSSAI Validity Date": "FSSAI Validity Date",
          "Date Of Registration": formValues2.customer_type!=="Sub Distributor" ?"Date Of Registration*": "Date of Registration",
          "PAN Status": "PAN Status",
          "ITR Start": "ITR Start",
          "Biscuits": "Biscuits",
          "Cakes": "Cakes",
          "Cookies": "Cookies",
          "Rusk": "Rusk",
          "Wafer": "Wafer",
        };
        

        const fetchAllCustomerLogs=async(matid)=>{
                const body={
                  modulename: "Customer",
                  recordid: matid
                }
                console.log("log body>> ", body)
                try{
                  const response= await fetchAuditLog(body);
                  const res= response.data;
                  if(res.status){
                    setAllAuditLogs(res.data);
                    console.log("logs fetched>> ", res.data);
                  }else{
                    console.log("could not bring cust logs>> ", res)
                  }
                }catch(error){
                  console.log("error bringing cust logs>> ", error);
                }
              }

              const renderArrayFields = (field, value) => {
                if (Array.isArray(value)) {
                  return value.map((item, idx) => (
                    <div key={`${field}-${idx}`} style={{ paddingLeft: 20, marginBottom: 10 }}>
                      {Object.entries(item).map(([key, val], index) => (
                        <div key={`${field}-${idx}-${index}`}>
                          <strong>{key}:</strong> {val || '-'}
                        </div>
                      ))}
                    </div>
                  ));
                }
              
                return null;
              };

        const handleChange = (name, value) => {
          console.log("Name:", name, "Value:", value);  
          const fieldKeyMap = {
            "FSSAI Validity Date": "fssiv",
            "Date Of Registration": "regdt",
            "Currency": "waers",
            "Biscuits": "bscts",
            "Cakes": "cknck",
            "Cookies": "both0",
            "Rusk": "rusk0",
            "PAN Status": "pan_stat",
            "ITR Start": "itr_stat",
            "Customer Code":"sap_code"
          };

//           const today = new Date();
// const yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;



if (name === "Withholding Tax Type 2") {
  const [typeVal, codeVal] = value.includes('#') ? value.split('#') : [value, ""];

  setFormValues2(prev => ({
    ...prev,
    withholding_tax_type_2: typeVal || "",
    reference_id: refId
  }));

  setApprovalFields(prev => {
    const updatedFields = prev.final.map(field => {
      if (field.name === "Withholding Tax Type 2") {
        return { ...field, value: typeVal || "" };
      }
      return field;
    });
    return { final: updatedFields };
  });

  setDialogOpen(false);
  setDialogOpen2(false);
  setSearchTerm("");
  setSearchTerm2("");

} else if (name === "Withholding Tax Code 2") {
  const [typeVal, codeVal] = value.includes('#') ? value.split('#') : ["", value];

  setFormValues2(prev => ({
    ...prev,
    withholding_tax_code_2: codeVal || "",
    reference_id: refId
  }));

  setApprovalFields(prev => {
    const updatedFields = prev.final.map(field => {
      if (field.name === "Withholding Tax Code 2") {
        return { ...field, value: codeVal || "" };
      }
      return field;
    });
    return { final: updatedFields };
  });

  setDialogOpen(false);
  setDialogOpen2(false);
  setSearchTerm("");
  setSearchTerm2("");

} else if (name === "Withholding Tax Type" || name === "Withholding Tax Code") {
  const [typeVal = "", codeVal = ""] = value ? value.split('#') : ["", ""];

  setFormValues2(prev => ({
    ...prev,
    withholding_tax_type: typeVal,
    withholding_tax_code: codeVal,
    reference_id: refId
  }));

  setApprovalFields(prev => {
    const updatedFields = prev.final.map(field => {
      if (field.name === "Withholding Tax Type") {
        return { ...field, value: typeVal };
      }
      if (field.name === "Withholding Tax Code") {
        return { ...field, value: codeVal };
      }
      return field;
    });
    return { final: updatedFields };
  });

  setDialogOpen(false);
  setDialogOpen2(false);
  setSearchTerm("");
  setSearchTerm2("");
}
 else {
  const key = fieldKeyMap[name] || name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  setFormValues2(prev => ({
    ...prev,
    [key]: value,
    reference_id: refId
  }));

  setApprovalFields(prev => {
    const updatedFields = prev.final.map(field =>
      field.name === name ? { ...field, value } : field
    );
    console.log("here are updated fields in approvalFields>> ", updatedFields);
    return { final: updatedFields };
  });

  setDialogOpen(false);
  setDialogOpen2(false);
  setSearchTerm("");
  setSearchTerm2("");
}

        };

        useEffect(() => {
          const delayDebounce = setTimeout(() => {
            if (typedCode) {
              fetchAllApprovers(typedCode,enteredEmployeeType);
            }
          }, 300); // 300ms debounce time
        
          return () => clearTimeout(delayDebounce);
        }, [typedCode]);
    

        const fetchAllApprovers=async(enteredCode,enteredName)=>{
          console.log("api called>>> ", enteredCode, enteredName)
          setIsActive(true);
          const body={
            empcode: enteredCode,
            empType: enteredName
          }
          console.log("body for approve>> ", body)
          try{
            const response= await fetchApproverDetails(body);
            const res= response.data;
            if(res.status){
              console.log("fetched approvers>> ", res);
              setIsActive(false)
              if(res.result){

                if(enteredName==="SO"){
                  let today = new Date();
                  let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;

                  setFormValues3((prevState) => ({
                    ...prevState,
                    reference_id: selectedVendor.reference_id,
                    so_name: res.result.zsoName,
                    
                    so_email: res.result.zsoMailid,
                    so_date: yyyymmdd
                  }));
  
  
  
                }else if(enteredName==="ASM"){
                  let today = new Date();
                  let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                  setFormValues3((prevState) => ({
                    ...prevState,
                    reference_id: selectedVendor.reference_id,
                    asm_name: res.result.zasmName,
                    
                    asm_email: res.result.zasmMailid,
                    asm_date: yyyymmdd
                  }));
  
                } else if(enteredName==="RSM"){
                  let today = new Date();
                  let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                  setFormValues3((prevState) => ({
                    ...prevState,
                    reference_id: selectedVendor.reference_id,
                    rsm_name: res.result.zrsmName,
                    
                    rsm_email: res.result.zrsmMailid,
                    rsm_date: yyyymmdd
                  }));
                }else if(enteredName==="ZSM"){
                  let today = new Date();
                  let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                  setFormValues3((prevState) => ({
                    ...prevState,
                    reference_id: selectedVendor.reference_id,
                    zsm_name: res.result.zzsmName,
                   
                    zsm_email: res.result.zzsmMailid,
                    zsm_date: yyyymmdd
                  }));
                }else if(enteredName==="NSM"){
                  let today = new Date();
                  let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                  setFormValues3((prevState) => ({
                    ...prevState,
                    reference_id: selectedVendor.reference_id,
                    nsm_name: res.result.znsmName,
                   
                    nsm_email: res.result.znsmMailid,
                    nsm_date: yyyymmdd
                  }));
                }else if(enteredName==="DSM"){
                  setFormValues3((prevState) => ({
                    ...prevState,
                    reference_id: selectedVendor.reference_id,
                    dsm_name: res.result.zdsmName,
                    
                    dsm_email: res.result.zdsmMailid,
                  }));
                }else if(enteredName==="SRM"){
                  setFormValues3((prevState) => ({
                    ...prevState,
                    reference_id: selectedVendor.reference_id,
                    srm_name: res.result.zsrName,
                    
                    srm_email: res.result.zsrMailid,
                  }));
                }
              }else {
                  if(enteredName==="SO"){
                    let today = new Date();
                    let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
  
                    setFormValues((prevState) => ({
                      ...prevState,
                      so_emp_code: '',
                      so_name: '',
                     
                      so_email: '',
                      so_date: ''
                    }));
    
    
    
                  }else if(enteredName==="ASM"){
                    let today = new Date();
                    let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                    setFormValues((prevState) => ({
                      ...prevState,
                     asm_emp_code: '',
                      asm_name: '',
                     
                      asm_email: '',
                      asm_date: ''
                    }));
    
                  } else if(enteredName==="RSM"){
                    let today = new Date();
                    let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                    setFormValues((prevState) => ({
                      ...prevState,
                      rsm_emp_code: '',
                      rsm_name: '',
                     
                      rsm_email: '',
                      rsm_date: ''
                    }));
                  }else if(enteredName==="ZSM"){
                    let today = new Date();
                    let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                    setFormValues((prevState) => ({
                      ...prevState,
                      zsm_emp_code: '',
                      zsm_name: '',
                      
                      zsm_email: '',
                      zsm_date: ''
                    }));
                  }else if(enteredName==="NSM"){
                    let today = new Date();
                    let yyyymmdd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
                    setFormValues((prevState) => ({
                      ...prevState,
                     nsm_emp_code: '',
                      nsm_name: '',
                      
                      nsm_email: '',
                      nsm_date: ''
                    }));
                  }else if(enteredName==="DSM"){
                    setFormValues((prevState) => ({
                      ...prevState,
                      dsm_emp_code: '',
                      dsm_name: '',
                     
                      dsm_email: '',
                    }));
                  }else if(enteredName==="SRM"){
                    setFormValues((prevState) => ({
                      ...prevState,
                      srm_emp_code: '',
                      srm_name: '',
                      
                      srm_email: '',
                    }));
                  }
                
                setFormValues3((prevState) => ({
                  ...prevState,
                  reference_id: selectedVendor.reference_id,
                 
                }));
              }
              
            }else{
              console.log("Could not bring approvers>> ", res);
              setIsActive(false)
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.warning("Could not bring approvers",{
                  className:"small-toast"
                })
              }
            }
          }catch(err){
            console.log("error fetching approver data>> ", err);
            setIsActive(false)
            if(!toast.isActive(toastId.current)){
              toastId.current= toast.warning(err.message,{
                className:"small-toast"
              })
            }
            if(err.response?.status==403){
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error("Your Session Has Expired",{
                  className:"small-toast"
                })
              }
              setTimeout(()=>{
                navigate("/")
                localStorage.clear();
              },2000)
            }
          }
        }

        const convertToSnakeCase = (str) =>
          str.toLowerCase().replace(/\s+/g, "_").replace(/[^\w_]/g, "");
        
        // const updateFields = (fields, data) =>{

        //   const fieldMapping = {
        //     bscts: "Biscuits",
        //     cknck: "Cakes",
        //     both0: "Cookies",
        //     rusk0: "Rusk",
        //     pan_stat: "PAN Status",
        //     itr_stat: "ITR Start",
        //   };
        //   return fields.map(field => {
        //     // First try matching by field name directly
        //     const matchingKey = Object.keys(data).find(key => field.name.toLowerCase() === key.toLowerCase());
        
        //     // If direct match found, use that
        //     if (matchingKey) {
        //       return { ...field, value: data[matchingKey] };
        //     }
        
        //     // Else, try to find mapped value
        //     const vendorKey = Object.keys(fieldMapping).find(key => field.name === fieldMapping[key]);
        
        //     if (vendorKey && data[vendorKey] !== undefined) {
        //       return { ...field, value: data[vendorKey] };
        //     }
        
        //     // Otherwise return field as-is
        //     return field;
        //   });


        //   // fields.map((field) => {
        //   //   const key = convertToSnakeCase(field.name);
        //   //   if (key in data) {
        //   //     return {
        //   //       ...field,
        //   //       value: data[key],
        //   //     };
        //   //   }
        //   //   return field;
        //   // });
        // }

        const updateFields = (fields, data) => {
  const fieldMapping = {
    bscts: "Biscuits",
    cknck: "Cakes",
    both0: "Cookies",
    rusk0: "Rusk",
    waers: "Currency",
    pan_stat: "PAN Status",
    itr_stat: "ITR Start",
    regdt: "Date Of Registration",
    fssiv: "FSSAI Validity Date",
    sap_code: "Customer Code",
    wafer: "Wafer"
  };

  return fields.map((field) => {
    const fieldKey = field.name === "Currency" ? field.name : convertToSnakeCase(field.name);
    console.log("Checking field:", field.name);
    console.log("Converted fieldKey:", fieldKey);

    // direct match
    if (fieldKey in data) {
      console.log(`✅ Direct match found for "${field.name}" with value:`, data[fieldKey]);
      return {
        ...field,
        value: data[fieldKey],
      };
    }

    // reverse lookup using mapping
    const mappedKey = Object.keys(fieldMapping).find((k) =>
      fieldMapping[k] === "Currency"
        ? fieldMapping[k] === fieldKey
        : convertToSnakeCase(fieldMapping[k]) === fieldKey
    );

    if (mappedKey && mappedKey in data) {
      console.log(`🌀 Mapped match for "${field.name}" -> "${mappedKey}" with value:`, data[mappedKey]);
      return {
        ...field,
        value: data[mappedKey],
      };
    }

    console.log(`❌ No match for "${field.name}"`);
    return field;
  });
};

        
        
        

        const months = ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb","Mar"]

  const capitalizeHeader = (header) => {
    return header
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
  };

  useEffect(()=>{
    // let localForm= localStorage.getItem("customerForm");
    // let parsedForm= JSON.parse(localForm);
    // console.log("do you have a form>> ", parsedForm)
    // if(parsedForm!==null){

    //   setFormValues(parsedForm)
    // //   setApprovalStatus(parsedForm.approval_status.value)
    // }
    let portalUser= JSON.parse(localStorage.getItem("userdetails"));
    if(portalUser){

      setUserID(portalUser.id);
      setUserName(portalUser.name)
      console.log("id is>> ", portalUser.id)
    }
    let msme= localStorage.getItem("msme");
    let fssi= localStorage.getItem("fssi");
    setIsMsme(JSON.parse(msme));
    setIsFssi(JSON.parse(fssi));
    const storedUser = JSON.parse(localStorage.getItem("userDetails"));
    let user_roleDetails= JSON.parse(localStorage.getItem("userRoles"));
    if(user_roleDetails){
      console.log("cust approval is>> ", user_roleDetails)
      setApprovalAllowed(user_roleDetails[0].customer_approval==1? true:false)
      setEditAllowed(user_roleDetails[0].customer_edit==1? true:false)
    }
    if(storedUser){
      setIsApprover1(storedUser.level==="approver-1");
    }
    fetchAllCustomerKDS();
  },[]);

  // console.log("Last>> ", approverData,lastApproverDetails)


  const addRow = () => {
    setFormValues((prevValues) => ({
      ...prevValues,
      area_alloted: [...prevValues.area_alloted, { town_name: '', population: '', distance_from_godown: '' }]
    }));
  };
  
  const removeRow = (index) => {
    setFormValues((prevValues) => {
      const updatedAreaAlloted = [...prevValues.area_alloted];
      updatedAreaAlloted.splice(index, 1);
      return { ...prevValues, area_alloted: updatedAreaAlloted };
    });
  };

  const isFormValid = () => {
    // Check required string fields
    const requiredFields = [
      "registration_type",
      "sub_town_village_name",
      "working_town_village_name",
      "party_type",
      "date_of_association",
      "association_years",
    ];
  
    for (const field of requiredFields) {
      if (typeof formValues[field] !== "string" || formValues[field].trim() === "") {
        return false;
      }
    }
  
    // Ensure reference_id is a valid number
    if (typeof formValues.reference_id !== "number" || isNaN(formValues.reference_id)) {
      return false;
    }
  
    // Check if all area_alloted fields are filled
    for (const area of formValues.area_alloted) {
      if (
        typeof area.town_name !== "string" || area.town_name.trim() === "" ||
        typeof area.population !== "string" || area.population.trim() === "" ||
        typeof area.distance_from_godown !== "string" || area.distance_from_godown.trim() === ""
      ) {
        return false;
      }
    }
  
    // Ensure at least one target has a valid monthly value
    const hasValidTarget = formValues.targets.some((target) => 
      Object.values(target.months).some((value) => typeof value === "string" && value.trim() !== "")
    );
  
    return hasValidTarget;
  };
  


  const fetchCustomers=async(status)=>{
    setIsActive(true)
    let body;
    let localuser= JSON.parse(localStorage.getItem("userdetails"))
    let useID= localuser.id
    if(status!==""&&status!==undefined&& status!==null){
      body={
        page: 1,
        customer_status: status,
        search: latestSearchRef.current,
        userID: useID
      }
    }else{
      body={
       page:latestSearchRef.current==""? currentPage: 1,
       search: latestSearchRef.current,
       customer_status: selectedStatus,
       userID: useID
     }

    }

    console.log("ven body>> ", body)

    try{
      const response= await fetchAllCustomer(body);
      const res= response.data;
      console.log("printing res>>> ", res);
      if(res.status){
        console.log("fetched custs>> ", res.data);
        setCustomerDetails(res.data);
     
        setIsActive(false)
        setTotalPages(res.totalPages)
      }else{
        console.log("not fetched custs>> ", res);
        setCustomerDetails([]);
        setTotalPages(1)
        setIsActive(false)
      }
    }catch(error){
      console.log("err in cust fetch>> ", error);
      setCustomerDetails([]);
      setTotalPages(1);
      setIsActive(false)
       if(error.response?.status==403){
                  if(!toast.isActive(toastId.current)){
                    toastId.current= toast.error("Your Session has expired",{
                      className:"small-toast"
                    })
                  }
                  setTimeout(()=>{
                    navigate("/")
                    localStorage.clear();
                  },2000)
                  return;
                }
    }
  }

  useEffect(()=>{
    fetchCustomers();
  },[currentPage])

  const handlePageChange=(p)=>{
    setCurrentPage(p)
    
  }
  
  // const vendorDetails = [
  //   {
  //     tradeName: formValues.firm_name.value || "ABC Corp",
  //     status: formValues.firm_status.value || "LLC",
  //     city: formValues.city.value || "New York",
  //     state: formValues.state.value || "NY",
  //     email: formValues.contact_person_email.value || "contact@abccorp.com",
  //     mobile: formValues.contact_person_mobile.value || "123-456-7890",
    
  //   },
  //   // {
  //   //   tradeName: 'ABC Corp',
  //   //   typeOfFirm: 'LLC',
  //   //   city: 'New York',
  //   //   state: 'NY',
  //   //   email: 'contact@abccorp.com',
  //   //   mobile: '123-456-7890',
  //   // },
  //   // {
  //   //   tradeName: 'XYZ Ltd.',
  //   //   typeOfFirm: 'Private',
  //   //   city: 'San Francisco',
  //   //   state: 'CA',
  //   //   email: 'info@xyzltd.com',
  //   //   mobile: '987-654-3210',

  //   // },
  //   // Add more vendors as needed
  // ];


  const handleFormChange = (field, value, index = null, materialIndex = null) => {
    setFormValues((prevState) => {
        let updatedState = { ...prevState };
        updatedState.reference_id= refId
        updatedState.approved_by= userID

        // Update `area_alloted` when index is provided but materialIndex is null
        if (index !== null && materialIndex === null) {
            const updatedAreaAlloted = [...prevState.area_alloted];
            updatedAreaAlloted[index] = {
                ...updatedAreaAlloted[index],
                [field]: value,
            };
            updatedState.area_alloted = updatedAreaAlloted;
        }

        // Update `targets` for a specific material and month
        if (materialIndex !== null) {
            const updatedTargets = [...prevState.targets];
            updatedTargets[materialIndex] = {
                ...updatedTargets[materialIndex],
                months: {
                    ...updatedTargets[materialIndex].months,
                    [field]: value,
                },
            };
            updatedState.targets = updatedTargets;
        }

        // General field update if neither `index` nor `materialIndex` is provided
        if (index === null && materialIndex === null) {
          // if (field === "date_of_association") {
          //   const dateObj = new Date(value);
          //   const day = String(dateObj.getDate()).padStart(2, '0');
          //   const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          //   const year = dateObj.getFullYear();
          //   updatedState[field] = `${year}${month}${day}`;
          // }
          
            updatedState[field] = value;
            
        }

        return updatedState;
    });
};



const handleFormChange2 = (field, value) => {
  setFormValues3((prevState) => {
      let updatedState = { ...prevState };
      updatedState.reference_id= refId
          updatedState[field] = value;
          updatedState.approved_by= userID
          
      

      return updatedState;
  });
};



  const handleOpenModal = (vendor) => {
    setSelectedVendor(vendor);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedVendor(null);
  };


  const formatToDDMMYYYY = (rawStr) => {
    if (!/^\d{8}$/.test(rawStr)) return "";
  
    const year = rawStr.slice(0, 4);
    const month = rawStr.slice(4, 6);
    const day = rawStr.slice(6, 8);
    // console.log("here is date result with raw>> ", rawStr, `${day}-${month}-${year}`)
    return `${day}-${month}-${year}`;
  };


  
  

  const handleOpenDialog = (vendor) => {
    setAllApproveDetails(vendor.all_approver_details)
    fetchAllCustomerLogs(vendor.reference_id)
    const { approval_details, lastapproval_details, sap_request,sap_response,all_approver_details, ...cleanVendor } = vendor;


    setSelectedVendor(cleanVendor);
    console.log("my cust is>> ", cleanVendor)
    console.log("first approve is>> ", vendor.approval_details)
    setApproverData(vendor.approval_details);
    setRefId(vendor.reference_id)
    setLastApproverDetails(vendor.lastapproval_details);
    setCustomerStatus(vendor.approval_status)
    const updatedValues = {};
    
    Object.keys(formValues).forEach((key) =>{
      if (key === "area_alloted"){

        if(vendor.areaDetails== null || vendor.areaDetails== undefined || vendor.areaDetails.length===0){
          updatedValues[key] = formValues.area_alloted;
          return
        }
        updatedValues[key] = vendor.areaDetails.map(detail => ({
          town_name: detail.town_name || '',
          population: detail.population || '',
          distance_from_godown: detail.distance_from_godown || ''
        }));
        console.log("updated areas>> "  ,updatedValues[key])
        return
      }
      if (key === "targets") {
        const updatedTargets = formValues.targets.map(target => {
          // filter the matching entries for this product_type
          const matchingEntries = vendor.targetDetails.filter(entry => entry.product_type === target.name);
        
          // clone the months object
          const updatedMonths = { ...target.months };
        
          // now, update months if data exists
          matchingEntries.forEach(entry => {
            if (updatedMonths.hasOwnProperty(entry.month)) {
              updatedMonths[entry.month] = entry.value;
            }
          });
        
          return {
            ...target,
            months: updatedMonths,
          };
        });
        
        console.log("here are updated targets>> ", updatedTargets)
        // finally update the formValues

        updatedValues.targets= updatedTargets
        // setFormValues(prev => ({
        //   ...prev,
        //   targets: updatedTargets,
        // }));
        return;
      };
      if (vendor.hasOwnProperty(key)){

        updatedValues[key] = vendor[key]||'';
        return;
      }
    })
    if(vendor?.sap_code){
      console.log("sap code is>>> ", vendor.sap_code)
      updatedValues.associated_to_sap_code= vendor.sap_code
      
    }else{
      updatedValues.registration_type="New"
    }
    console.log("here is updated 1st approve>> ", updatedValues) 
    setFormValues(updatedValues)
    setFormValues(prev=>({
      ...prev,
      reference_id: vendor.reference_id,

      approved_by: userID
    }))



    setFormValues2(prev=>({
      ...prev,
      reference_id: vendor.reference_id,
      approved_by: userID,
      bp_grouping: vendor.bp_grouping,
      sap_code: vendor.sap_code,
      customer_type: vendor.customer_type,
      language:'EN',
      type:vendor.type,
      search_term_1: vendor.search_term_1,
      search_term_2: vendor.search_term_2,
      company_code: vendor.company_code,
      customer_group: vendor.customer_group,
      grouping_key: vendor.grouping_key,
      order_combination: vendor.order_combination,
      reconciliation_account: vendor.reconciliation_account,
      account_assignment_group: vendor.account_assignment_group,
      account_statement: vendor.account_statement,
      sort_key: vendor.sort_key,
      payment_terms: vendor.payment_terms,
      payment_methods: vendor.payment_methods,
      sales_organisation: vendor.sales_organisation,
      distribution_channel: vendor.distribution_channel,
      division: vendor.division,
      sales_district: vendor.sales_district,
      region: vendor.region,
      sub_group: vendor.sub_group,
      zone: vendor.zone,
      district_code: vendor.district_code,
      town_code: vendor.town_code,
      block_code: vendor.block_code,
      sales_office: vendor.sales_office,
      sales_group: vendor.sales_group,
      price_list: vendor.price_list,
      delivery_priority: vendor.delivery_priority,
      order_probability: vendor.order_probability,
      customer_pricing_procedure: vendor.customer_pricing_procedure,
      shipping_conditions: vendor.shipping_conditions,
      bank_key: vendor.bank_key,
      record_payment_history: vendor.record_payment_history,
      withholding_tax_type: vendor.withholding_tax_type,
      withholding_tax_type_2: vendor.withholding_tax_type_2,
      withholding_tax_code: vendor.withholding_tax_code,
      withholding_tax_code_2: vendor.withholding_tax_code_2,
      withholding_tax_identification_number: vendor.withholding_tax_identification_number,
      withholding_tax_identification_number_2: vendor.withholding_tax_identification_number_2,
      withholding_agent: vendor.withholding_agent,
      withholding_agent_2: vendor.withholding_agent_2,
      withholding_start_date: vendor.withholding_start_date,
      withholding_start_date_2: vendor.withholding_start_date_2,
      tax_type_3: vendor.tax_type_3,
      max_part_deliveries: vendor.max_part_deliveries,
      incoterms: vendor.incoterms,
      incoterms_location: vendor.incoterms_location,
      fssiv: vendor.fssiv,
      regdt: vendor.regdt,
      waers: vendor.waers || 'INR',
      bscts: vendor.bscts,
      cknck: vendor.cknck,
      both0: vendor.both0,
      rusk0: vendor.rusk0,
      wafer: vendor.wafer,
      pan_stat: vendor.pan_stat,
      itr_stat: vendor.itr_stat,
    }));

    setFormValues3(prev => ({
      ...prev,
      reference_id: vendor.reference_id,
      approved_by: userID,
      so_name: vendor.so_name,
      so_emp_code: vendor.so_emp_code,
      so_email: vendor.so_email,
      so_date: vendor.so_date,
      asm_name: vendor.asm_name,
      asm_emp_code: vendor.asm_emp_code,
      asm_email: vendor.asm_email,
      asm_date: vendor.asm_date,
      rsm_name: vendor.rsm_name,
      rsm_emp_code: vendor.rsm_emp_code,
      rsm_email: vendor.rsm_email,
      rsm_date: vendor.rsm_date,
      zsm_name: vendor.zsm_name,
      zsm_emp_code: vendor.zsm_emp_code,
      zsm_email: vendor.zsm_email,
      zsm_date: vendor.zsm_date,
      nsm_name: vendor.nsm_name,
      nsm_emp_code: vendor.nsm_emp_code,
      nsm_email: vendor.nsm_email,
      nsm_date: vendor.nsm_date,
      dsm_name: vendor.dsm_name,
      dsm_emp_code: vendor.dsm_emp_code,
      dsm_email: vendor.dsm_email,
      dsm_date: vendor.dsm_date,
      srm_name: vendor.srm_name,
      srm_emp_code: vendor.srm_emp_code,
      srm_email: vendor.srm_email,
      srm_date: vendor.srm_date
    }));
    

    const updated = updateFields(approvalFields.final, vendor);
    console.log("here is updated>> ", updated)
    setApprovalFields((prev) => ({ ...prev, final: updated }));


    // setOpenApproverDialog(true)
    setOpenDialog(true);
    
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setCustomerSearch(value);
    latestSearchRef.current = value;

    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

   
typingTimeoutRef.current = setTimeout(() => {
  fetchCustomers(); // Inside this function, access latest value from latestSearchRef.current
}, 2000);

   
  };


  function formatDate(value) {
    if (!value) return '';
  
    // If value is already in YYYYMMDD format
    if (typeof value === 'string' && value.length === 8 && /^\d{8}$/.test(value)) {
      const year = value.substring(0, 4);
      const month = value.substring(4, 6);
      const day = value.substring(6, 8);
      return `${year}-${month}-${day}`;
    }
  
    // If value is in YYYY-MM-DD or similar format
    const dateObj = new Date(value);
  
    // If date is valid, format it
    if (!isNaN(dateObj.getTime())) {
      return dateObj.toISOString().split('T')[0];
    }
  
    // If invalid, don't touch it. Let the user keep typing.
    return value;
  }

  function formatMyDate(dateTimeStr) {
    const date = new Date(dateTimeStr);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setIsEdit(false)
    setSelectedVendor(null);
  };

  const handleEditRequest=()=>{
    setIsEdit(true)
  }

  const handleCloseApprover=()=>{
    setOpenApproverDialog(false)
  }

  const handleInfraApprove=async()=>{
    setIsActive(true)
    console.log("sales form>> ", formValues3)

    // if (
    //   (!formValues3.so_name || formValues3.so_name === '') &&
    //   (!formValues3.so_emp_code || formValues3.so_emp_code === '') &&
    //   (!formValues3.so_email || formValues3.so_email === '') &&
    //   (!formValues3.so_date || formValues3.so_date === '')
    
    //   (!formValues3.dsm_name || formValues3.dsm_name === '') &&
    //   (!formValues3.dsm_emp_code || formValues3.dsm_emp_code === '') &&
    //   (!formValues3.dsm_email || formValues3.dsm_email === '') 
    
    //   (!formValues3.srm_name || formValues3.srm_name === '') &&
    //   (!formValues3.srm_emp_code || formValues3.srm_emp_code === '') &&
    //   (!formValues3.srm_email || formValues3.srm_email === '') 
    // ){
    //   if(!toast.isActive(toastId.current)){
    //     toastId.current= toast.warning("Please fill the fields for: SO, DSM & SRM",{
    //       className:"small-toast"
    //     })
    //   }
    //   setIsActive(false)
    //   return;
    // }

    try{

      const response= await saveCustomerPortalForm1(formValues3);
      const res= response.data;
      if(res.status){
        setOpenApproverDialog(false);
        setIsActive(false);
        setOpenComment(true)
      }else{
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Could not save data",{
            className:"small-toast"
          })
        }
        setIsActive(false);
        console.log("could not save field values>> ", res)
      }

    }catch(err){
      setIsActive(false)
      console.log("error in saving fields>> ", err)
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.error(err.message,{
          className:"small-toast"
        })
      }
      if(err.response?.status==403){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Your Session has expired",{
            className:"small-toast"
          })
        }
        setTimeout(()=>{
          navigate("/")
          localStorage.clear();
        },2000)
        return;
      }
    
    }
  }

    const fetchAllCustomerKDS=async()=>{
            try{
              const response= await fetchKDSCustomer();
              const res= response.data;
              if(res.status){
                setKdsdata(res.data);
                setZData(res.data.miszone)
                console.log("here is zone mis>> ", res.data.miszone)
                console.log("kds fetched>> ", res.data);
              }else{
                console.log("could not bring material kds>> ", res)
              }
            }catch(error){
              console.log("error bringing material KDS>> ", error);
            }
          }

           const fetchCustomerBySapCode=async()=>{
            setIsActive(true)
            const body={
              sap_code: stockistCode
            }
            try{
              const response= await fetchCustomerByCode(body);
              const res= response.data;
              if(res.status){
                setIsActive(false)
                // setKdsdata(res.data);
                if(res.data && res.data.trim()){

                  setFormValues(prev => ({
                       ...prev,
                       concern_super_stockist: stockistCode + '-' + res.data
                     }));
                }else{
                   setFormValues(prev => ({
                       ...prev,
                       concern_super_stockist: ''
                     }));
                }
                // setZData(res.data.miszone)
                console.log("here is stockist details>> ", res)
                // console.log("kds fetched>> ", res.data);
              }else{
                setIsActive(false)
                 setFormValues(prev => ({
                       ...prev,
                       concern_super_stockist: ''
                     }));
                console.log("could not bring stockist data>> ", res)
              }
            }catch(error){
              setIsActive(false)
               setFormValues(prev => ({
                       ...prev,
                       concern_super_stockist: ''
                     }));
              console.log("error bringing stockist data>> ", error);
            }
          }


          useEffect(() => {
              const handler = setTimeout(() => {
                setSearchLoader(true); // Show loader AFTER 2 sec pause
                setDebouncedSearch(searchTerm);
            
                // Simulate async filtering (optional delay or set false immediately after)
                setTimeout(() => {
                  setSearchLoader(false); // Hide loader after data is "ready"
                }, 100); // tweak delay if needed
              }, 600); // Wait for user to stop typing
            
              return () => clearTimeout(handler); // Cleanup if typing again
            }, [searchTerm]);
          
            useEffect(() => {
              const handler = setTimeout(() => {
                setSearchLoader(true); // Show loader AFTER 2 sec pause
                setDebouncedSearch(searchTerm2);
            
                // Simulate async filtering (optional delay or set false immediately after)
                setTimeout(() => {
                  setSearchLoader(false); // Hide loader after data is "ready"
                }, 100); // tweak delay if needed
              }, 600); // Wait for user to stop typing
            
              return () => clearTimeout(handler); // Cleanup if typing again
            }, [searchTerm2]);


  const filteredData = kdsdata[keySelected]?.filter(
    (item) =>
      item.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.value.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // const handleApproval=()=>{
  //   if(isDept || isAcc){
  //     setOpenApproverDialog(true)
  //   }else{
  //     if(!toast.isActive(toastId.current)){
  //                toastId.current= toast.success( isIT? "IT Approval Successful": "MDM Approval Successful",{
  //                  className:"small-toast"
  //                })
  //              }

  //             setApprovalStatus(isIT? "it_approved": "mdm_approved")
  //             formValues.approval_status.value= isIT? "it_approved": "mdm_approved";
  //             localStorage.setItem("filledForm", JSON.stringify(formValues))
  //   }
  // }

  const saveApproval=async()=>{
    setIsActive(true)
    const body={
      "approvalid": approverData[0].id,
    "customer_id":refId,
    "user_id":userID,
    "status": "1" ,
    "comment": comment
    }
    console.log("approval body>>> ", body)
    try{
      const response= await submitCustomerApproval(body);
      const res= response.data;
      if(res.status){
        console.log("customer approved success", res);
        setIsActive(false)
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.success(res.message,{
            className:"small-toast"
          })
        }
        setOpenApproverDialog(false);
        setOpenDialog(false);
        setOpenComment(false)
        fetchCustomers();
      }else{
        setIsActive(false)
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.warning(res.message,{
            className:"small-toast"
          })
        }
        console.log("could not approve>> ", res)
      }
    }catch(error){
      setIsActive(false)
      console.log("error in approving>> ", error)
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.error(error.message,{
          className:"small-toast"
        })
      }
      if(error.response?.status==403){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Your Session has expired",{
            className:"small-toast"
          })
        }
        setTimeout(()=>{
          navigate("/")
          localStorage.clear();
        },2000)
        return;
      }
    }
  }

  const handleApproval=()=>{
    console.log("last 2>> ", lastApproverDetails)
    if(approverData[0].designation==="ASM" ||approverData[0].designation==="Infra Officer" || lastApproverDetails[0].user_id==userID){
      setOpenApproverDialog(true)
    }else{
      setOpenComment(true);
    }
  }

  const handleAccountsApproval=(e)=>{
    e.preventDefault();
    formValues.approval_status.value="accounts_approved";
    localStorage.setItem("filledForm", JSON.stringify(formValues))
    if(!toast.isActive(toastId.current)){
      toastId.current= toast.success("Accounts Approval Successful",{
        className:"small-toast"
      })
    }
    setApprovalStatus("accounts_approved")
  }

  const handleFirstApprove=async(e)=>{
    e.preventDefault();
    setIsActive(true);
    const { sub_town_village_name, working_town_village_name, party_type, targets } = formValues;
    
    // Get month string like 'May' from date_of_fillup
    const monthIndex = Number(selectedVendor?.date_of_fillup?.substring(4, 6)); // e.g., "05"
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const targetMonth = monthNames[monthIndex - 1]; // Convert number to month name like 'May'
    
    const isBasicInfoMissing =
      !sub_town_village_name.trim() ||
      !working_town_village_name.trim() ||
      !party_type.trim();
    
    const isTargetMonthMissing = targets.some(item => !item.months[targetMonth]?.trim());
    
    if (isBasicInfoMissing || isTargetMonthMissing) {
      setIsActive(false);
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(
          `Please fill all mandatory fields: Sub Town/Village, Working Town/Village, Party Type and the "${targetMonth}" target.`,
          { className: "small-toast" }
        );
      }
      return;
    }

    if(formValues.registration_type=="Replacement"){
      if(formValues.associated_to_sap_code==""){
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error(
            `Please fill the associated to sap code for replacement.`,
            { className: "small-toast" }
          );
        }
        setIsActive(false);
        return;
      }
    }
     if (formValues2.customer_type == "Sub Distributor" && !formValues.concern_super_stockist?.trim()) {
      setIsActive(false);
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(
          `Please fill the Concern Super Stockist for Sub Distributor.`,
          { className: "small-toast" }
        );
      }
      return;
    }
    console.log("form is>> ", formValues);

    try{

      const response= await saveCustomerPortalForm1(formValues);
      const res= response.data;
      if(res.status){
        setOpenApproverDialog(false);
        setIsActive(false);
        setOpenComment(true)
      }else{
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Could not save data",{
            className:"small-toast"
          })
        }
        setIsActive(false);
        console.log("could not save field values>> ", res)
      }

    }catch(err){
      setIsActive(false)
      console.log("error in saving fields>> ", err)
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.error(err.message,{
          className:"small-toast"
        })
      }
      if(err.response?.status==403){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Your Session has expired",{
            className:"small-toast"
          })
        }
        setTimeout(()=>{
          navigate("/")
          localStorage.clear();
        },2000)
        return;
      }
    
    }

   

    const saveApproval=async()=>{
      setIsActive(true)
      const body={
        "approvalid": approverData[0].id,
      "customer_id":refId,
      "user_id":userID,
      "status": "1" 
      }
      try{
        const response= await submitCustomerApproval(body);
        const res= response.data;
        if(res.status){
          console.log("customer approved success", res);
          setIsActive(false)
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.success(res.message,{
              className:"small-toast"
            })
          }
          setOpenApproverDialog(false);
          setOpenDialog(false);
          fetchCustomers();
        }else{
          setIsActive(false)
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.warning(res.message,{
              className:"small-toast"
            })
          }
          console.log("could not approve>> ", res)
        }
      }catch(error){
        setIsActive(false)
        console.log("error in approving>> ", err)
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error(error.message,{
            className:"small-toast"
          })
        }
        if(error.response?.status==403){
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.error("Your Session has expired",{
              className:"small-toast"
            })
          }
          setTimeout(()=>{
            navigate("/")
          },2000)
          return;
        }
      }
    }

    
  }

  const handleFinalApproval=async(e)=>{
    e.preventDefault();
    setIsActive(true)
    console.log("form is>> ", formValues2);

    if(formValues2.incoterms!==""){
      if(formValues2.incoterms_location==""){
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error(`Please fill Incoterms Location for Incoterm`, {
            className: 'small-toast'
          });
        }
        setIsActive(false);
        return;
      }
    }

    const mandatoryFields = [
      { key: 'bp_grouping', label: 'BP Grouping' },
      
      { key: 'region', label: 'Region' },
     
      { key: 'search_term_1', label: 'Search Term 1' },
      // { key: 'payment_terms', label: 'Payment Terms' },
     
      // { key: 'payment_methods', label: 'Payment Methods' },
     
      { key: 'sub_group', label: 'Sub Group' },
      { key: 'zone', label: 'Zone' },
    ];

    if (formValues2.customer_type !== "Sub Distributor") {
      mandatoryFields.push(
        { key: 'withholding_tax_type', label: 'Withholding Tax Type' },
        { key: 'withholding_tax_code', label: 'Withholding Tax Code' },
        { key: 'withholding_tax_identification_number', label: 'Withholding Tax Identification Number' },
        { key: 'withholding_agent', label: 'Withholding Agent' },
        { key: 'withholding_start_date', label: 'Withholding Start Date' },
        { key: 'withholding_tax_type_2', label: 'Withholding Tax Type 2' },
        // withholding_tax_code_2 is NOT included
        { key: 'withholding_tax_identification_number_2', label: 'Withholding Tax Identification Number 2' },
        { key: 'withholding_agent_2', label: 'Withholding Agent 2' },
        { key: 'withholding_start_date_2', label: 'Withholding Start Date 2' },
        { key: 'tax_type_3', label: 'Tax Type 3' },
        { key: 'customer_group', label: 'Customer Group' },
        { key: 'price_list', label: 'Price List' },
        { key: 'customer_pricing_procedure', label: 'Customer Pricing Procedure' },
         { key: 'reconciliation_account', label: 'Reconciliation account' },
          { key: 'company_code', label: 'Company Code' },
          { key: 'shipping_conditions', label: 'Shipping Condition' },
           { key: 'sales_office', label: 'Sales Office' },
          { key: 'sales_group', label: 'Sales Group' },
           { key: 'sales_office', label: 'Sales Office' },
      { key: 'regdt', label: 'Date of Registration' },
      );
    }
  
    // Collect missing fields
    const missingFields = mandatoryFields.filter(field => !formValues2[field.key]?.trim());

    // if (formValues2.withholding_tax_type?.trim() !== '') {
    //   if (!formValues2.withholding_tax_code?.trim()) {
    //     missingFields.push({ key: 'withholding_tax_code', label: 'Withholding Tax Code' });
    //   }
    //   if (!formValues2.withholding_start_date?.trim()) {
    //     missingFields.push({ key: 'withholding_start_date', label: 'Withholding Start Date' });
    //   }
    // }
    
    // if (formValues2.withholding_tax_type_2?.trim() !== '') {
    //   if (!formValues2.withholding_start_date_2?.trim()) {
    //     missingFields.push({ key: 'withholding_start_date_2', label: 'Withholding Start Date 2' });
    //   }
    // }
  
    if (missingFields.length > 0) {
      setIsActive(false);
      const fieldNames = missingFields.map(field => field.label).join(', ');
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.error(`Please fill the following required fields: ${fieldNames}`, {
          className: 'small-toast'
        });
      }
      return; // Stop function if validation fails
    }
  

    try{

      const response= await saveCustomerPortalForm1(formValues2);
      const res= response.data;
      if(res.status){
        setOpenApproverDialog(false);
        setIsActive(false);
        setOpenComment(true)
      }else{
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Could not save data",{
            className:"small-toast"
          })
        }
        setIsActive(false);
        console.log("could not save field values>> ", res)
      }

    }catch(err){
      setIsActive(false)
      console.log("error in saving fields>> ", err)
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.error(err.message,{
          className:"small-toast"
        })
      }
      if(err.response?.status==403){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Your Session has expired",{
            className:"small-toast"
          })
        }
        setTimeout(()=>{
          navigate("/")
          localStorage.clear();
        },2000)
        return;
      }
    
    }

    
  }

  const handleReject=async()=>{
    setIsActive(true)
    const body={
      "approvalid": approverData[0].id,
    "customer_id":refId,
    "user_id":userID,
    "status": "2" 
    }
    try{
      
      const response= await submitCustomerApproval(body);
      const res= response.data;
      if(res.status){
        console.log("customer reject success", res);
        setIsActive(false)
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.success(res.message,{
            className:"small-toast"
          })
        }
        setOpenApproverDialog(false);
        setOpenDialog(false);
        setOpenComment2(false)
        fetchCustomers();
      }else{
        setIsActive(false)
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.success(res.message,{
            className:"small-toast"
          })
        }
        console.log("could not approve>> ", res)
      }
    }catch(error){
      setIsActive(false)
      console.log("error in approving>> ", err)
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.success(error.message,{
          className:"small-toast"
        })
      }
      if(error.response?.status==403){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Your Session has expired",{
            className:"small-toast"
          })
        }
        setTimeout(()=>{
          navigate("/")
          localStorage.clear();
        },2000)
        return;
      }
    }

  }

  const handleDropdownClick = (keyName,field) => {
    if(field==="Zone"){
      setIsActive(true)
      let filteredData = zData
      .map(item => item[keyName])
      .filter(value => value && value.trim() !== '');
      setFilteredZone(filteredData)
      console.log("Filtered zone>>> ", filteredData)
      setKeySelected(keyName);
    setSelectedField(field)
      setDialogOpen2(true);
      setIsActive(false)
      return;
    }
    if(field==="Sub Group"){
      let filteredData = zData
      .map(item => item[keyName])
      .filter(value => value && value.trim() !== '');
      setFilteredZone(filteredData)
      console.log("Filtered zone>>> ", filteredData)
      setKeySelected(keyName);
    setSelectedField(field)
      setDialogOpen2(true);
      return;
    }
    console.log("here is key and name>> ", keyName, field)
    setKeySelected(keyName);
    setSelectedField(field)
    setDialogOpen(true);      // Open the dialog
  };

  const handleEditCustomer=()=>{
    localStorage.setItem("editFormCustomer", JSON.stringify(selectedVendor))
    navigate("/customer/edit-details")
  }

  const handleApproverEdit=(ven)=>{
    localStorage.setItem("editFormCustomerApprover", JSON.stringify(ven))
    navigate("/customer/approver/edit-details")
  }

  return(
    <DashboardLayout>
        <DashboardNavbar/>
        <ToastContainer/>
        <SimpleBackdrop openLoader={isActive}/>
        <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px', flexWrap: 'wrap', marginBottom: '20px'  }}>
 <ButtonGroup className="mb-3" style={{ gap: "10px" }}>
                <Button
                  variant={selectedStatus === "all" ? "danger" : "outline-danger"}
                  onClick={() => {
                    setSelectedStatus("all")
                    fetchCustomers("all")}}
                  className="filterButton"
                >
                  All
                </Button>
                <Button
                  variant={selectedStatus === "pending" ? "danger" : "outline-danger"}
                  onClick={() =>{ 
                    setSelectedStatus("pending")
                    fetchCustomers("pending")}}
                 className="filterButton"
                >
                  Pending
                </Button>
                <Button
                  variant={selectedStatus === "approved" ? "danger" : "outline-danger"}
                  onClick={() => {
                    setSelectedStatus("approved")
                    fetchCustomers("approved")}}
                  className="filterButton"
                >
                  Approved
                </Button>
                <Button
                  variant={selectedStatus === "rejected" ? "danger" : "outline-danger"}
                  onClick={() => {
                    setSelectedStatus("rejected")
                    fetchCustomers("rejected")}}
                  className="filterButton"
                >
                  Rejected
                </Button>
               
              </ButtonGroup>
              <input
      type="text"
      placeholder="Search with name or SAP code"
      className="form-control searchMaterialBOX"
      style={{  fontSize: "12px"}}
      onChange={handleSearchChange}
    />
              
            </div>
         <div style={{width: '100%', overflowX: 'auto', marginBottom: '20px'}}>
        <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
        <thead>
          <tr style={{color : "white",backgroundColor: "#3498db"}}>
           
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >FIRM NAME</th>
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >FIRM STATUS</th>
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >PROPRIETER NAME</th>
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >PAN</th>
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >SAP CODE</th>
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >CUSTOMER TYPE</th>
                <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >DOCUMENT STATUS</th>
              {selectedStatus!=="all" && <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >APPROVAL STATUS</th>}
              <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >CREATED ON</th>
              <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' ,  textTransform: 'uppercase'}} >CREATED BY</th>
            <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0', fontSize: "15px" }}>ACTION</th>
          </tr>
        </thead>
        <tbody>
        {customerDetails.map((customer) => (
            <tr key={customer.reference_id}>
             
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{customer.firm_name}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{customer.firm_status}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{customer.proprietor_name}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{customer.pan}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{customer.sap_code}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{customer.customer_type}</td>
                  <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{customer.approval_status.toUpperCase()}</td>
                {selectedStatus!=="all" && <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{customer.status==1?"APPROVED":customer.status==2?"REJECTED":"PENDING"}</td>}  
                <td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{customer.info?.created_on}</td>
<td style={{ whiteSpace: 'nowrap', fontSize: "12px" }}>{`${customer.info?.name} (${customer.info?.userid})`}</td>
              <td >
                <SoftButton variant="text" color="error" onClick={() => handleOpenDialog(customer)}>
                <Icon sx={{color:'red'}}>visibility</Icon>
              </SoftButton>
              {customer?.approval_status === "approved" &&
              
              <SoftButton variant="text" color="error" onClick={() => handleApproverEdit(customer)}>
                <Icon sx={{color:'red'}}>edit</Icon>
              </SoftButton>
              }
              </td>
            </tr>
          ))}
        </tbody>
        </Table>
        </div>   
        </div>

         {/* <Pagination className="mt-3">
                <Pagination.Prev 
                  disabled={currentPage === 1} 
                  onClick={() => handlePageChange(currentPage - 1)}
                />
                {[...Array(totalPages).keys()].map((page) => (
                  <Pagination.Item 
                    key={page + 1} 
                    active={page + 1 === currentPage} 
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next 
                  disabled={currentPage === totalPages} 
                  onClick={() => handlePageChange(currentPage + 1)}
                />
              </Pagination> */}

               <Pagination className="mt-3">
                <Pagination.Prev
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                  style={{
                    color: "danger",
                    borderRadius: "5px",
                  }}
                />
              
                {/* Always show first page */}
                <Pagination.Item
                  active={currentPage === 1}
                  onClick={() => handlePageChange(1)}
                  style={{
                    color: currentPage === 1 ? "#fff" : "danger",
                    backgroundColor: currentPage === 1 ? "danger" : "transparent",
                    borderRadius: "5px",
                  }}
                >
                  1
                </Pagination.Item>
              
                {/* Left dots */}
                {currentPage > 3 && <Pagination.Ellipsis disabled />}
              
                {/* Middle page numbers */}
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(
                    (page) =>
                      page !== 1 &&
                      page !== totalPages &&
                      Math.abs(currentPage - page) <= 1
                  )
                  .map((page) => (
                    <Pagination.Item
                      key={page}
                      active={page === currentPage}
                      onClick={() => handlePageChange(page)}
                      style={{
                        color: page === currentPage ? "#fff" : "danger",
                        backgroundColor: page === currentPage ? "danger" : "transparent",
                        borderRadius: "5px",
                      }}
                    >
                      {page}
                    </Pagination.Item>
                  ))}
              
                {/* Right dots */}
                {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}
              
                {/* Always show last page */}
                {totalPages > 1 && (
                  <Pagination.Item
                    active={currentPage === totalPages}
                    onClick={() => handlePageChange(totalPages)}
                    style={{
                      color: currentPage === totalPages ? "#fff" : "danger",
                      backgroundColor:
                        currentPage === totalPages ? "danger" : "transparent",
                      borderRadius: "5px",
                    }}
                  >
                    {totalPages}
                  </Pagination.Item>
                )}
              
                <Pagination.Next
                  disabled={currentPage === totalPages}
                  onClick={() => handlePageChange(currentPage + 1)}
                  style={{
                    color: "danger",
                    borderRadius: "5px",
                  }}
                />
              </Pagination>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullScreen
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div style={{display:'flex', justifyContent:'space-between'}}>


          <span style={{fontSize: "30px",color:'red',fontWeight:'bold'}}>Customer Details</span>

          <SoftTypography color="error" variant="h5">{selectedVendor?.sap_message}</SoftTypography>

          <SoftBox display="flex" justify-content= "space-between" gap={2}>
          {approvalAllowed && approverData[0]?.user_id==userID && customerStatus=== "pending" ? (
              
              
              <>
              
          <SoftButton
                        variant="contained"
                        color="success"
                        onClick={handleApproval}
                      >
                        Approve
                      </SoftButton>
                      <SoftButton
                        variant="contained"
                        color="error"
                        onClick={()=>setOpenComment2(true)}
                      >
                        Reject
                      </SoftButton>
              </>  
                ): (
                  <>
                 {selectedVendor?.approval_status === "approved" ? (
            <SoftTypography color="success" variant="h5">Customer Approved</SoftTypography>
          ) : selectedVendor?.approval_status === "rejected" ? (
            <SoftTypography color="error" variant="h5">Customer Rejected</SoftTypography>
          ) : null}
          
                  </>
                )
          
              }
              </SoftBox>
          
            
          </div>
          
        </DialogTitle>
        <DialogContent>
           <Tabs
                            defaultActiveKey="profile"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                            activeKey={selectedTab}
                            onSelect={(k)=>{
                              
                              setSelectedTab(k)}}
                          >
                            <Tab eventKey="details" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Details</span>}>
                            
        <SoftBox className="bp">
 <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    GENERAL DATA
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      {selectedVendor?.customer_type=="Sub Distributor" &&
      
       <tr>
        <td><strong>Concern Super Stockist</strong></td>
        <td>{selectedVendor?.concern_super_stockist}</td>
      </tr>
      }
      <tr>
        <td><strong>Name of Firm</strong></td>
        <td>{selectedVendor?.firm_name}</td>
        <td><strong>Status of Firm</strong></td>
        <td>{selectedVendor?.firm_status}</td>
      </tr>
      <tr>
        <td><strong>Street</strong></td>
        <td>{selectedVendor?.street}</td>
        <td><strong>PO Box</strong></td>
        <td>{selectedVendor?.po_box}</td>
      </tr>
      <tr>
        <td><strong>Block Name/Taluka</strong></td>
        <td>{selectedVendor?.block_tehsil}</td>
        <td><strong>Main Town/Village Name</strong></td>
        <td>{selectedVendor?.main_town_village}</td>
      </tr>
      <tr>
        <td><strong>Sub Town/ Village Name</strong></td>
        <td>{selectedVendor?.sub_town_village_name}</td>
        <td><strong>Working Town/Village</strong></td>
        <td>{selectedVendor?.working_town_village_name}</td>
      </tr>
      <tr>
        <td><strong>District Name</strong></td>
        <td>{selectedVendor?.district_name}</td>
         <td><strong>Customer Type</strong></td>
        <td>{selectedVendor?.customer_type}</td>
        </tr>
      <tr>
        <td><strong>State Name</strong></td>
        <td>{ kdsdata?.region?.find(item => item.value ==selectedVendor?.state)?.label}</td>
        <td><strong>Post Office</strong></td>
        <td>{selectedVendor?.post_office}</td>
      </tr>
      <tr>
        <td><strong>Police Station</strong></td>
        <td>{selectedVendor?.police_station}</td>
        <td><strong>Name of Proprietor / Partners / Directors</strong></td>
        <td>{selectedVendor?.proprietor_name}</td>
        
      </tr>
      <tr>
        <td><strong>Contact No</strong></td>
        <td>{selectedVendor?.proprietor_mobile}</td>
        <td><strong>Proprieter Email Id</strong></td>
        <td>{selectedVendor?.proprietor_email}</td>
      </tr>
      <tr>
        <td><strong>Date of Birth of Proprietor</strong></td>
        <td>{formatToDDMMYYYY(selectedVendor?.proprietor_dob)}</td>
        <td><strong>Name of Contact Person</strong></td>
        <td>{selectedVendor?.contact_person}</td>
      </tr>
      <tr>
        <td><strong>Contact Person Telephone</strong></td>
        <td>{selectedVendor?.contact_person_mobile}</td>
        <td><strong>Contact Person Mobile</strong></td>
        <td>{selectedVendor?.mobile}</td>
      </tr>
      <tr>
        <td><strong>Contact Person Email</strong></td>
        <td>{selectedVendor?.contact_person_email}</td>
        <td><strong>BP Grouping</strong></td>
        <td>{ kdsdata?.bpgrp?.find(item => item.value ==selectedVendor?.bp_grouping)?.label }</td>
      </tr>
     
      <tr>
        <td><strong>Search Term 1</strong></td>
        <td>{selectedVendor?.search_term_1}</td>
        <td><strong>Search Term 2</strong></td>
        <td>{selectedVendor?.search_term_2}</td>
      </tr>
      <tr>
        <td><strong>Date of Association</strong></td>
        <td>{formatToDDMMYYYY(selectedVendor?.date_of_association)}</td>
        <td><strong>Language</strong></td>
        <td>{selectedVendor?.language}</td>
      </tr>
      <tr>
        <td><strong>Date of Registration</strong></td>
        <td>{formatToDDMMYYYY(selectedVendor?.regdt)}</td>
        <td><strong>SAP Code</strong></td>
        <td>{selectedVendor?.sap_code}</td>
      </tr>
    </tbody>
  </Table>
  </>

  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    BUSINESS DETAILS
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      <tr>
        <td><strong>GSTIN</strong></td>
        <td>{selectedVendor?.gstn}</td>
        <td><strong>FSSAI No</strong></td>
        <td>{selectedVendor?.fssi_regn_no}</td>
      </tr>
      <tr>
        <td><strong>PAN</strong></td>
        <td>{selectedVendor?.pan}</td>
        <td><strong>PAN Status</strong></td>
        <td>{selectedVendor?.pan_stat}</td>
      </tr>
      <tr>
        <td><strong>Registration Type</strong></td>
        <td>{selectedVendor?.registration_type}</td>
        <td><strong>Party Type</strong></td>
        <td>{selectedVendor?.party_type}</td>
      </tr>
      <tr>
        <td><strong>Aadhaar</strong></td>
        <td>{selectedVendor?.aadhaar}</td>
        <td><strong>TAN</strong></td>
        <td>{selectedVendor?.tan}</td>
      </tr>
      <tr>
        <td><strong>CIN (if applicable)</strong></td>
        <td>{selectedVendor?.cin}</td>
        <td><strong>Company Code</strong></td>
        <td>{ kdsdata?.compcode?.find(item => item.value ==selectedVendor?.company_code)?.label}</td>
        
      </tr>
      <tr>
        <td><strong>Grouping Key</strong></td>
        <td>{selectedVendor?.grouping_key}</td>
        <td><strong>Reconciliation Account</strong></td>
        <td>{ kdsdata?.reconacc?.find(item => item.value ==selectedVendor?.reconciliation_account)?.label}</td>
      </tr>
      <tr>
        <td><strong>Account Assignment Group</strong></td>
        <td>{ kdsdata?.custacntgrp?.find(item => item.value ==selectedVendor?.account_assignment_group)?.label}</td>
        <td><strong>Account Statement</strong></td>
        <td>{selectedVendor?.account_statement}</td>
      </tr>
      <tr>
        <td><strong>Sort Key</strong></td>
        <td>{ kdsdata?.sortkey?.find(item => item.value ==selectedVendor?.sort_key)?.label}</td>
        <td><strong>Payment Terms</strong></td>
        <td>{ kdsdata?.payterms?.find(item => item.value ==selectedVendor?.payment_terms)?.label}</td>
      </tr>
      <tr>
        <td><strong>Payment Methods</strong></td>
        <td>{ kdsdata?.paymthd?.find(item => item.value ==selectedVendor?.payment_methods)?.label}</td>
        <td><strong>BP Grouping</strong></td>
        <td>{ kdsdata?.bpgrp?.find(item => item.value ==selectedVendor?.bp_grouping)?.label}</td>
      </tr>
     
      <tr>
        <td><strong>Record Payment History</strong></td>
        <td>{selectedVendor?.record_payment_history}</td>
        <td><strong>Withholding Tax Type</strong></td>
        <td>{selectedVendor?.withholding_tax_type}</td>
      </tr>
      <tr>
        <td><strong>Withholding Tax Code</strong></td>
        <td>{selectedVendor?.withholding_tax_code}</td>
        <td><strong>Withholding Tax Identification Number</strong></td>
        <td>{selectedVendor?.withholding_tax_identification_number}</td>
      </tr>
      <tr>
      <td><strong>Withholding Agent</strong></td>
        <td>{selectedVendor?.withholding_agent}</td>
        <td><strong>Withholding Start Date</strong></td>
        <td>{formatToDDMMYYYY(selectedVendor?.withholding_start_date)}</td>
      </tr>
      <tr>
        <td><strong>Withholding Tax Type 2</strong></td>
        <td>{selectedVendor?.withholding_tax_type_2}</td>
        <td><strong>Withholding Tax Code 2</strong></td>
        <td>{selectedVendor?.withholding_tax_code_2}</td>
      </tr>
      <tr>
        <td><strong>Withholding Tax Identification Number 2</strong></td>
        <td>{selectedVendor?.withholding_tax_identification_number_2}</td>
        <td><strong>Withholding Agent 2</strong></td>
        <td>{selectedVendor?.withholding_agent_2}</td>
      </tr>
      <tr>
        <td><strong>Withholding Start Date 2</strong></td>
        <td>{formatToDDMMYYYY(selectedVendor?.withholding_start_date_2)}</td>
        <td><strong>Investment Amount Plan for Anmol(Rs.)</strong></td>
        <td>{selectedVendor?.inpln}</td>
      </tr>

      <tr>
      <td><strong>Tax Type 3</strong></td>
        <td>{ kdsdata?.taxtype?.find(item => item.value ==selectedVendor?.tax_type_3)?.label}</td>
        <td><strong>ROC status of company whether exist or strike of</strong></td>
        <td>{selectedVendor?.roc_status}</td>
      </tr>

      <tr>
      <td><strong>Company Code</strong></td>
      <td>{ kdsdata?.compcode?.find(item => item.value ==selectedVendor?.company_code)?.label}</td>
      </tr>

    </tbody>
  </Table>
  </>

  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    BANK DETAILS
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      <tr>
        <td><strong>Bank Account No</strong></td>
        <td>{selectedVendor?.bank_account_number}</td>
        <td><strong>IFSC Code</strong></td>
        <td>{selectedVendor?.ifsc_code}</td>
      </tr>
      <tr>
        <td><strong>Bank Name</strong></td>
        <td>{selectedVendor?.bank_name}</td>
        <td><strong>Bank Branch Name</strong></td>
        <td>{selectedVendor?.bank_branch_name}</td>
      </tr>
      <tr>
        <td><strong>Undated Cheque 1</strong></td>
        <td>{selectedVendor?.undated_cheque_1}</td>
        <td><strong>Undated Cheque 2</strong></td>
        <td>{selectedVendor?.undated_cheque_2}</td>
      </tr>
      <tr>
        <td><strong>Undated Cheque 3</strong></td>
        <td>{selectedVendor?.undated_cheque_3}</td>
      </tr>
    </tbody>
  </Table>
  </>

  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    STORAGE DETAILS
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      <tr>
        <td><strong>Godown Area</strong></td>
        <td>{selectedVendor?.godown_area}</td>
        <td><strong>Godown Type</strong></td>
        <td>{selectedVendor?.godown_type}</td>
      </tr>
      <tr>
        <td><strong>Delivery Vehicle Type (Rickshaw)</strong></td>
        <td>{selectedVendor?.del_type_van==="X"?"Yes":"No"}</td>
        <td><strong>Delivery Vehicle Type (Auto Van)</strong></td>
        <td>{selectedVendor?.del_type_van==="X"?"Yes":"No"}</td>
      </tr>
      <tr>
        <td><strong>Auto Van Model No (if auto van delivery type)</strong></td>
        <td>{selectedVendor?.model_no_van}</td>
        <td><strong>Customer Salesman 1</strong></td>
        <td>{selectedVendor?.customer_salesman_1}</td>
      </tr>
      <tr>
        <td><strong>Customer Salesman Mobile 1</strong></td>
        <td>{selectedVendor?.customer_salesman_no_1}</td>
        <td><strong>Customer Salesman 2</strong></td>
        <td>{selectedVendor?.customer_salesman_2}</td>
      </tr>

      <tr>
        <td><strong>Customer Salesman Mobile 2</strong></td>
        <td>{selectedVendor?.customer_salesman_no_2}</td>
        <td><strong>Week Off Followed By Customer</strong></td>
        <td>{selectedVendor?.customer_weekoff}</td>
      </tr>
    </tbody>
  </Table>
  </>

  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    SALES DATA
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      <tr>
        <td><strong>Customer Group</strong></td>
        <td>{ kdsdata?.custgrp?.find(item => item.value ==selectedVendor?.customer_group)?.label}</td>
        <td><strong>Order Combination</strong></td>
        <td>{selectedVendor?.order_combination}</td>
      </tr>
      <tr>
        <td><strong>Sales Organization</strong></td>
        <td>{kdsdata?.salesorg?.find(item => item.value ==selectedVendor?.sales_organisation)?.label}</td>
        <td><strong>Sales District</strong></td>
        <td>{kdsdata?.saldstrct?.find(item => item.value ==selectedVendor?.sales_district)?.label}</td>
      </tr>
      <tr>
        <td><strong>Sales Office</strong></td>
        <td>{kdsdata?.saleofc?.find(item => item.value ==selectedVendor?.sales_office)?.label}</td>
        <td><strong>Sales Group</strong></td>
        <td>{kdsdata?.salegrp?.find(item => item.value ==selectedVendor?.sales_group)?.label}</td>
      </tr>
      <tr>
        <td><strong>Price List</strong></td>
        <td>{kdsdata?.priclst?.find(item => item.value ==selectedVendor?.price_list)?.label}</td>
        <td><strong>Delivery Priority</strong></td>
        <td>{selectedVendor?.delivery_priority}</td>
        
      </tr>
      <tr>
        <td><strong>Distribution Channel</strong></td>
        <td>{kdsdata?.distchnl?.find(item => item.value ==selectedVendor?.distribution_channel)?.label}</td>
        <td><strong>Division</strong></td>
        <td>{kdsdata?.division?.find(item => item.value ==selectedVendor?.division)?.label}</td>
      </tr>
      <tr>
        <td><strong>Region</strong></td>
        <td>{kdsdata?.region?.find(item => item.value ==selectedVendor?.region)?.label}</td>
        <td><strong>Sub Group</strong></td>
        <td>{selectedVendor?.sub_group}</td>
      </tr>
      <tr>
        <td><strong>Zone</strong></td>
        <td>{selectedVendor?.zone}</td>
        <td><strong>District code</strong></td>
        <td>{selectedVendor?.district_code}</td>
      </tr>
      <tr>
        <td><strong>Town Code</strong></td>
        <td>{selectedVendor?.town_code}</td>
        <td><strong>Block Code</strong></td>
        <td>{selectedVendor?.block_code}</td>
      </tr>
     
      <tr>
        <td><strong>Order Probability</strong></td>
        <td>{selectedVendor?.order_probability}</td>
        <td><strong>Currency</strong></td>
        <td>{kdsdata?.ordrcurr?.find(item => item.value ==selectedVendor?.currency)?.label}</td>
      </tr>
      <tr>
        <td><strong>Customer Pricing Procedure</strong></td>
        <td>{kdsdata?.pricprcd?.find(item => item.value ==selectedVendor?.customer_pricing_procedure)?.label}</td>
        <td><strong>Shipping Conditions</strong></td>
        <td>{kdsdata?.shipcond?.find(item => item.value ==selectedVendor?.shipping_conditions)?.label}</td>
      </tr>
      <tr>
      <td><strong>Max Part Deliveries</strong></td>
        <td>{selectedVendor?.max_part_deliveries}</td>
        <td><strong>Incoterms</strong></td>
        <td>{kdsdata?.incoterms?.find(item => item.value ==selectedVendor?.incoterms)?.label}</td>
      </tr>
      <tr>
      <td><strong>Incoterms Location</strong></td>
        <td>{selectedVendor?.incoterms_location}</td>
        <td><strong>FSSAI Valid Till</strong></td>
        <td>{formatToDDMMYYYY(selectedVendor?.fssiv)}</td>
      </tr>
    </tbody>
  </Table>
  </>


  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    SALES TEAM DECLARATION
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
  <tbody>
  <tr>
    <td><strong>SO Code</strong></td>
    <td>{selectedVendor?.so_emp_code}</td>
    <td><strong>SO Name</strong></td>
    <td>{selectedVendor?.so_name}</td>
    <td><strong>SO Date</strong></td>
    <td>{formatToDDMMYYYY(selectedVendor?.so_date)}</td>
  </tr>
  <tr>
    <td><strong>ASM Code</strong></td>
    <td>{selectedVendor?.asm_emp_code}</td>
    <td><strong>ASM Name</strong></td>
    <td>{selectedVendor?.asm_name}</td>
    <td><strong>ASM Date</strong></td>
    <td>{formatToDDMMYYYY(selectedVendor?.asm_date)}</td>
  </tr>
  <tr>
    <td><strong>RSM Code</strong></td>
    <td>{selectedVendor?.rsm_emp_code}</td>
    <td><strong>RSM Name</strong></td>
    <td>{selectedVendor?.rsm_name}</td>
    <td><strong>RSM Date</strong></td>
    <td>{formatToDDMMYYYY(selectedVendor?.rsm_date)}</td>
  </tr>
  <tr>
    <td><strong>ZSM Code</strong></td>
    <td>{selectedVendor?.zsm_emp_code}</td>
    <td><strong>ZSM Name</strong></td>
    <td>{selectedVendor?.zsm_name}</td>
    <td><strong>ZSM Date</strong></td>
    <td>{formatToDDMMYYYY(selectedVendor?.zsm_date)}</td>
  </tr>
  <tr>
    <td><strong>NSM Code</strong></td>
    <td>{selectedVendor?.nsm_emp_code}</td>
    <td><strong>NSM Name</strong></td>
    <td>{selectedVendor?.nsm_name}</td>
    <td><strong>NSM Date</strong></td>
    <td>{formatToDDMMYYYY(selectedVendor?.nsm_date)}</td>
  </tr>
  <tr>
    <td><strong>DSM Code</strong></td>
    <td>{selectedVendor?.dsm_emp_code}</td>
    <td><strong>DSM Name</strong></td>
    <td>{selectedVendor?.dsm_name}</td>
  </tr>
  <tr>
    <td><strong>SRM Code</strong></td>
    <td>{selectedVendor?.srm_emp_code}</td>
    <td><strong>SRM Name</strong></td>
    <td>{selectedVendor?.srm_name}</td>
  </tr>
</tbody>

  </Table>
  </>
 


  {selectedVendor && (
    <>
     <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
     TOWN DETAILS
   </SoftTypography>
  <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
    <thead>
      <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>Town Name</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>Population</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>Distance From Godown</th>
      </tr>
    </thead>
    <tbody>
      {selectedVendor?.areaDetails.map((company) => (
        <tr key={company.id} className="border">
          <td className="border p-2">{company.town_name}</td>
          <td className="border p-2">{company.population}</td>
          <td className="border p-2">
            {company.distance_from_godown}
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
    </>
)}



           <form noValidate >
                                 <SoftBox py={3} className="customerblock">
                                   <Grid container spacing={3}>
                                     <Grid item xs={12} lg={12}>
                                       <Card sx={{ overflow: "visible" }}>
                                         <SoftBox p={3}>
                                           {/* <SoftTypography variant="h5" id="form_heading textUppercase">Vendor details</SoftTypography> */}
                        
                                           
                        
                                           <SoftBox mt={1}>
                                          <Grid container spacing={3}>


{selectedVendor && (
  <>
   <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
   COMPANY DETAILS
 </SoftTypography>
  <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
    <thead>
      <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>Company Name</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>Industry</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>Revenue</th>
      </tr>
    </thead>
    <tbody>
      {selectedVendor?.companies.map((company) => (
        <tr key={company.id} className="border">
          <td className="border p-2">{company.name_of_company}</td>
          <td className="border p-2">{company.company_brand}</td>
          <td className="border p-2">
            {company.monthly_turnover}
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
  </>
)}

{selectedVendor && (

<div style={{ overflowX: 'auto', width: '100%' }}>
<SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    MARKET DETAILS
  </SoftTypography>
  <Table striped bordered hover size="sm" style={{ fontSize: 12, minWidth: '1000px' }}>
    <thead>
      <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        {[
          "Day", "Beat Name 1", "Beat Name 2", "Distance from Godown 1", "Distance from Godown 2",
          "Expected Sales 1", "Expected Sales 2", "Retailer 1", "Retailer 2",
          "Wholesaler 1", "Wholesaler 2", "Frequency of Visit 1", "Frequency of Visit 2",
          "Ready Stock or Order Booking 1", "Ready Stock or Order Booking 2"
        ].map((heading, idx) => (
          <th
            key={idx}
            style={{
              whiteSpace: 'nowrap',
              backgroundColor: '#343333',
              color: '#FFF',
              textTransform: 'uppercase',
              padding: '8px'
            }}
          >
            {heading}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {selectedVendor?.marketDetails?.length > 0 ? (
        selectedVendor.marketDetails.map((market) => (
          <tr key={market.id}>
            <td>{market.day}</td>
            <td>{market.beatName_1}</td>
            <td>{market.beatName_2}</td>
            <td>{market.distanceFromGodown_1}</td>
            <td>{market.distanceFromGodown_2}</td>
            <td>{market.expectedDailySales_1}</td>
            <td>{market.expectedDailySales_2}</td>
            <td>{market.retailer_1}</td>
            <td>{market.retailer_2}</td>
            <td>{market.wholesaler_1}</td>
            <td>{market.wholesaler_2}</td>
            <td>{market.frequencyOfVisit_1}</td>
            <td>{market.frequencyOfVisit_2}</td>
            <td>{market.readyStockOrOrderBooking_1}</td>
            <td>{market.readyStockOrOrderBooking_2}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="15" className="text-center">No market data available</td>
        </tr>
      )}
    </tbody>
  </Table>
</div>




)}

{selectedVendor && (

<div style={{ overflowX: 'auto', width: '100%' }}>
<SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    TARGET DETAILS
  </SoftTypography>
  <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
    <thead>
      <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th
          style={{
            whiteSpace: "nowrap",
            backgroundColor: "#343333",
            color: "#FFFFF0",
            textTransform: "uppercase",
          }}
        >
          Product Type
        </th>
        {/* Dynamically render month headers */}
        {[...new Set(selectedVendor.targetDetails.map(item => item.month))].map(month => (
          <th
            key={month}
            style={{
              whiteSpace: "nowrap",
              backgroundColor: "#343333",
              color: "#FFFFF0",
              textTransform: "uppercase",
            }}
          >
            {month}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {[...new Set(selectedVendor.targetDetails.map(item => item.product_type))].map(product => (
        <tr key={product}>
          <td className="border p-2">{product}</td>
          {[...new Set(selectedVendor.targetDetails.map(item => item.month))].map(month => {
            const item = selectedVendor.targetDetails.find(
              i => i.product_type === product && i.month === month
            );
            return (
              <td key={month} className="border p-2">
               {item.value}
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  </Table>

</div>
)}

           
           
             {/* Render JPG and PDF links at the end, side by side */}
    

<>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    UPLOADED DOCUMENTS
  </SoftTypography>
  <Table striped bordered hover style={{ fontSize: 11, width: "100%" }}>
    <tbody>
      <tr>
        <td><strong>GSTIN Document</strong></td>
        <td>{selectedVendor?.gstin_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.gstin_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
    </a>
  ) : (
    ""
  )}</td>
        <td><strong>PAN Document</strong></td>
        <td>{selectedVendor?.pan_card_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.pan_card_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
    </a>
  ) : (
    ""
  )}</td>
      </tr>

      <tr>
        <td><strong>FSSAI License Document</strong></td>
        <td>{selectedVendor?.fssai_license_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.fssai_license_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
    </a>
  ) : (
    ""
  )}</td>
        <td><strong>TAN Document</strong></td>
        <td>{selectedVendor?.tan_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.tan_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
    </a>
  ) : (
    ""
  )}</td>
      </tr>

      <tr>
        <td><strong>Cancel Cheque Document</strong></td>
        <td>{selectedVendor?.cancel_cheque_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.cancel_cheque_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px",color:'red' }} />
    </a>
  ) : (
    ""
  )}</td>
        <td><strong>Three undated cheques document</strong></td>
        <td>{selectedVendor?.three_undated_cheques_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.three_undated_cheques_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
    </a>
  ) : (
    ""
  )}</td>
      </tr>

      <tr>
        <td><strong>Address Proof Document</strong></td>
        <td>{selectedVendor?.address_proof_document ? (
    <a
      href={`https://crm-backend.anmolindustries.com/${selectedVendor.address_proof_document}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        fontWeight: "bold",
        color: "#007bff",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <RemoveRedEyeIcon style={{ marginLeft: "5px" ,color:'red'}} />
    </a>
  ) : (
    ""
  )}</td>
      </tr>
     
    </tbody>
  </Table>
  </>

  <>
  <SoftTypography variant="h5" color="error" gutterBottom style={{ marginTop: 20, fontWeight: 'bold' }}>
    APPROVER DETAILS
  </SoftTypography>
  <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
    <thead>
      <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVER NAME</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVER EMAIL</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVAL STATUS</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>APPROVED ON</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#343333', color: '#fff', textTransform: 'uppercase' }}>COMMENT</th>
      </tr>
    </thead>
    <tbody>
      {allApproveDetails?.map((company) => (
        <tr key={company.id} className="border">
          <td className="border p-2">{company.approver_name}</td>
          <td className="border p-2">{company.email}</td>
          <td className="border p-2">
            {company.status}
          </td>
          <td className="border p-2">{company.approved_on}</td>
          <td className="border p-2">{company.comment}</td>
        </tr>
      ))}
    </tbody>
  </Table>
  </>




           </Grid>
           
           
           
                                           </SoftBox>
                        
                        
                                         
                                           
                        
                                           
                        
                                         </SoftBox>
                                       </Card>
                                     </Grid>
                                   </Grid>
                                 </SoftBox>
           
           
           

                                 {/* <SoftBox py={3} className="customerblock">
                                 <Grid container justifyContent="flex-end" mt={2} spacing={3}>
                         <Grid item xs={12} lg={12}>
                           
                             <SoftBox p={3}>
                               <Grid container justifyContent="flex-end" mt={2}>
                                 <Grid item>
                                   <SoftButton onClick={handleCloseDialog} variant="contained" color="error">
                                     Close
                                   </SoftButton>
                                 </Grid>
                                 <Grid item>
                                 
                                                 <SoftButton onClick={handleEditCustomer} variant="contained" color="error">
                                                   Edit
                                                 </SoftButton>
                                               </Grid>
                               </Grid>
                             </SoftBox>
                         </Grid>
                        </Grid>
                        </SoftBox> */}
                        
                                 </form>
            </SoftBox>
                            </Tab> 
                            <Tab eventKey="log" title={<span style={{ fontSize: '15px', fontWeight: 'bold', color: '#FF0000' }}>Log</span>}>
                            <>
  <SoftTypography
    variant="h5"
    color="error"
    gutterBottom
    style={{ marginTop: 20, fontWeight: 'bold' }}
  >
    CUSTOMER AUDIT LOG
  </SoftTypography>

  
 


{allAuditLogs?.length > 0 &&
  allAuditLogs.map((entry, i) => {
    const isUpdate = entry.action === 'UPDATE';
    const hasChangeData = isUpdate && Object.keys(entry.changedata || {}).length > 0;

    if (isUpdate && hasChangeData) {
      return(
        <div style={{ display: 'flex', alignItems: 'center', position: 'relative', borderLeft: '3px solid rgb(235, 85, 15)' }}>
          
          {/* Dot */}
          <div
            style={{
              position: 'absolute',
              left: -8,
              top: '50%',
              width: 14,
              height: 14,
              borderRadius: '50%',
              backgroundColor: 'rgb(235, 85, 15)',
              border: '2px solid white',
              boxShadow: '0 0 0 2px rgb(235, 85, 15)',
            }}
          />
      
          {/* Date */}
          <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingLeft: 40, paddingRight: 50, fontStyle: 'italic' }}>
            {entry.created_at}
          </div>
      
          {/* Card */}
          <div
            style={{
              backgroundColor: '#f4f6f7',
              padding: 20,
              borderRadius: 8,
              border: '1px solid #ccc',
              fontSize: 13,
              width: '80%',
              marginBottom: 20,
            }}
          >
            <div style={{ fontSize: '14px', paddingTop: 10, width: '100%', display: 'flex', marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '35px', height: '35px', borderRadius: '50%', backgroundColor: '#efefef', marginRight: 10, overflow: 'hidden', marginRight: 15 }}>
                  <img
                    src='https://www.transparentpng.com/thumb/user/gray-user-profile-icon-png-fP8Q1P.png'
                    alt="Profile"
                    style={{ width: '100%' }}
                  />
                </div>
                {/* <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingRight: 50, fontStyle: 'italic' }}> Admin</div> */}
              </div>
              <div style={{ backgroundColor: '#ceecdc', color: '#026933', padding: '3px', borderRadius: '5px' }}>{entry.action}</div>
            </div>
      
            {Object.entries(entry.changedata).map(([field, value], idx) => (
              <div key={idx} style={{ marginBottom: '15px' }}>
                <div><strong>Field:</strong> {fieldDisplayNames[field]  || '-'}</div>
      
                {field === 'area_alloted' && Array.isArray(value?.new) ? (
                  <>
                   <div>
                    <strong>Changed From:</strong>
                    <table style={{ marginTop: 8, width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Town name</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Population</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Distance From Godown</th>
                        </tr>
                      </thead>
                      <tbody>
                        {value?.old?.map((item, index) => (
                          <tr key={index}>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.town_name}</s></td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.population}</s></td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.distance_from_godown}</s></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <strong>To:</strong>
                    <table style={{ marginTop: 8, width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Town name</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Population</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Distance From Godown</th>
                        </tr>
                      </thead>
                      <tbody>
                        {value.new.map((item, index) => (
                          <tr key={index}>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.town_name}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.population}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.distance_from_godown}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  </>
                ) : field === 'companies' && Array.isArray(value?.new) ? (
                  <>
                  <div>
                    <strong>Changed From:</strong>
                    <table style={{ marginTop: 8, width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Company name</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Brand</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Monthly Turnover</th>
                        </tr>
                      </thead>
                      <tbody>
                        {value?.old?.map((item, index) => (
                          <tr key={index}>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.name_of_company}</s></td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.company_brand}</s></td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}><s>{item.monthly_turnover}</s></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <strong>To:</strong>
                    <table style={{ marginTop: 8, width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Company name</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Brand</th>
                          <th style={{ border: '1px solid #ccc', padding: '4px' }}>Monthly Turnover</th>
                        </tr>
                      </thead>
                      <tbody>
                        {value.new.map((item, index) => (
                          <tr key={index}>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.name_of_company}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.company_brand}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>{item.monthly_turnover}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  </>
                ) : field === 'marketDetails' && typeof value.new === 'object' ? (
                  <>
<div>
                    <strong>Changed From:</strong>
                    <div style={{ marginTop: 8 }}>
                    {value?.old ? (
  Object.entries(value.old).map(([day, details]) => (
    <div key={day} style={{ marginBottom: '16px', padding: '8px', border: '1px solid #ccc' }}>
      <div><strong>{day}:</strong></div>
      {details.map((detail, idx) => (
        <div key={idx} style={{ paddingLeft: '12px', marginTop: '8px' }}>
          <div><strong>Beat Name 1:</strong> <s>{detail.beatName_1}</s></div>
          <div><strong>Expected Daily Sales 1:</strong> <s>{detail.expectedDailySales_1}</s></div>
          <div><strong>Frequency of Visit 1:</strong> <s>{detail.frequencyOfVisit_1}</s></div>

          {detail.beatName_2 && (
            <div><strong>Beat Name 2:</strong> <s>{detail.beatName_2}</s></div>
          )}
          {detail.expectedDailySales_2 && (
            <div><strong>Expected Daily Sales 2:</strong> <s>{detail.expectedDailySales_2}</s></div>
          )}
          {detail.frequencyOfVisit_2 && (
            <div><strong>Frequency of Visit 2:</strong> <s>{detail.frequencyOfVisit_2}</s></div>
          )}
        </div>
      ))}
    </div>
  ))
) : (
  <></>
)}

                    </div>
                  </div>
                  <div>
                    <strong>To:</strong>
                    <div style={{ marginTop: 8 }}>
                      {Object.entries(value.new).map(([day, details]) => (
                        <div key={day} style={{ marginBottom: '16px', padding: '8px', border: '1px solid #ccc' }}>
                          <div><strong>{day}:</strong></div>
                          {details.map((detail, idx) => (
                            <div key={idx} style={{ paddingLeft: '12px', marginTop: '8px' }}>
                              <div><strong>Beat Name 1:</strong> {detail.beatName_1}</div>
                              <div><strong>Expected Daily Sales 1:</strong> {detail.expectedDailySales_1}</div>
                              <div><strong>Frequency of Visit 1:</strong> {detail.frequencyOfVisit_1}</div>
      
                              {detail.beatName_2 && <div><strong>Beat Name 2:</strong> {detail.beatName_2}</div>}
                              {detail.expectedDailySales_2 && <div><strong>Expected Daily Sales 2:</strong> {detail.expectedDailySales_2}</div>}
                              {detail.frequencyOfVisit_2 && <div><strong>Frequency of Visit 2:</strong> {detail.frequencyOfVisit_2}</div>}
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                  </>
                ) : field === 'targets' && Array.isArray(value) ? (
                  <div>
                    <strong>Changed To:</strong>
                    {value.map((target, idx) => (
                      <div key={idx} style={{ marginBottom: '16px', padding: '8px', border: '1px solid #ccc' }}>
                        <div><strong>Target Name:</strong> {target.name}</div>
                        {Object.entries(target.months).map(([month, targetValue], monthIdx) => (
                          <div key={monthIdx} style={{ paddingLeft: '12px' }}>
                            <strong>{month}:</strong> {targetValue}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div><strong>Changed From:</strong> <del>{value?.old || '-'}</del>{' '}<strong>To:</strong> {value?.new || '-'}</div>
                )}
              </div>
            ))}
      
            <div><strong>Changed By:</strong> {entry.userdetails?.[0]?.name || '-'}</div>
          </div>
        </div>
      )
    }else if(entry.action==="CREATE"){
      return(
<div style={{ display: 'flex', alignItems: 'center', position: 'relative', borderLeft: '3px solid rgb(235, 85, 15)' }}>
          {/* Dot */}
          <div
            style={{
              position: 'absolute',
              left: -8,
              top: '50%',
              width: 14,
              height: 14,
              borderRadius: '50%',
              backgroundColor: 'rgb(235, 85, 15)',
              border: '2px solid white',
              boxShadow: '0 0 0 2px rgb(235, 85, 15)'
            }}
          />
          {/* Timestamp */}
          <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingLeft: 40, paddingRight: 50, fontStyle: 'italic' }}>
            {entry.created_at}
          </div>
    
          {/* Card */}
          <div
            style={{
              backgroundColor: '#f4f6f7',
              padding: 20,
              borderRadius: 8,
              border: '1px solid #ccc',
              fontSize: 13,
              width: '80%',
              marginBottom: 20,
            }}
          >
            <div style={{ fontSize: '14px', paddingTop: 10, width: '100%', display: 'flex', marginBottom: 15, alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '35px', height: '35px', borderRadius: '50%', backgroundColor: '#efefef', marginRight: 15, overflow: 'hidden' }}>
                  <img
                    src='https://www.transparentpng.com/thumb/user/gray-user-profile-icon-png-fP8Q1P.png'
                    alt="Profile"
                    style={{ width: '100%' }}
                  />
                </div>
                <div style={{ fontSize: '14px', color: '#646464', fontWeight: 'bold', marginTop: 10, paddingRight: 50, fontStyle: 'italic' }}> Admin</div>
              </div>
              <div style={{ backgroundColor: '#ceecdc', color: '#026933', padding: '3px', borderRadius: '5px' }}>{entry.action}</div>
            </div>
    
            <div><strong>Customer Created</strong> </div>
          </div>
        </div>
      )
    }else{
      return;
    }
  })}
 

 
</>
                            </Tab>
                          </Tabs>
        </DialogContent>
            <DialogActions>

            <Grid container justifyContent="flex-end" mt={2} spacing={3}>
                         <Grid item>
                         <SoftButton onClick={handleCloseDialog} variant="contained" color="error">
                                     Close
                                   </SoftButton>
           
                         </Grid>
                         <Grid item>

                        {editAllowed && 
                        
                         <SoftButton onClick={handleEditCustomer} variant="contained" color="error">
                                                   Edit
                                                 </SoftButton>
                        }
                         </Grid>
                       </Grid>
            </DialogActions>
        
      </Dialog>

      <Dialog
        open={openApproverDialog}
        onClose={handleCloseApprover}
        
        fullScreen
      >
        <DialogTitle>
        <div style={{display:'flex', justifyContent:'space-between'}}>
        <span style={{fontSize: "25px"}}>Approval Fields</span>
        <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseApprover} // You can define this function to close the dialog
            aria-label="close"
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <SimpleBackdrop openLoader={isActive}/>
        </DialogTitle>
        <DialogContent>
          {lastApproverDetails[0]?.user_id==userID || (lastApproverDetails[0]?.user_id== approverData[0]?.user_id)
 ?(
            <form onSubmit={handleFinalApproval}>
              <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
                <CardContent>
                  <SoftBox py={2} style={{ overflowX: "auto" }}>
                    {[...new Set(approvalFields.final.map(field => field.block))].map((blockName, blockIndex) => (
                      <div key={blockIndex}>

                        <SoftTypography textDecoration="underline" variant="h5" fontWeight="bold" mt={2} mb={3}>
                        {blockName}
                      </SoftTypography>


                    <Grid container alignItems="center" spacing={2}>

                    {approvalFields.final.filter(field => field.block === blockName).map((field, index) => (
  <Grid item xs={14} sm={4} key={index + field.name}>
    <SoftTypography
      component="label"
      variant="caption"
      fontWeight="bold"
      textTransform="capitalize"
    >
      {fieldDisplayNames2[field.name]}
    </SoftTypography>

    {field.type === "dropdown" ? (
      <div onClick={() => handleDropdownClick(field.apiKey, field.name)}>
        <SoftInput
         fullWidth
          value={field.value}
          readOnly
        />
      </div>
    ) : field.type === "text" ? (
      <SoftInput
        type="text"
        fullWidth
        disabled={field.name==="Language"?true:false}
        value={field.name ==="Language"?formValues2.language : field.value}
        onChange={(e) => handleChange(field.name, e.target.value)}
      />
    ): field.type === "date" ?(

      <SoftInput
        type="date"
        fullWidth
        value={formatDate(field.value)}
        onChange={(e) => {
          const raw = e.target.value; // format: "2025-04-20"
          const [year, month, day] = raw.split("-");
          const formatted = `${year}${month}${day}`; // "20250420"
          console.log("here is formatted>> ", formatted)
          handleChange(field.name, formatted);
        }}
      />
  
    ): field.type === "date2" ?(

      <SoftInput
        type="date"
        fullWidth
        value={formatDate(field.value)}
        onChange={(e) => {
          const dateObj = new Date(e.target.value);
          const day = String(dateObj.getDate()).padStart(2, '0');
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const year = dateObj.getFullYear();
          const formattedDate = `${year}${month}${day}`;
          console.log("here is formattedDate>> ", formattedDate)  
          handleChange(field.name, formattedDate);
        }}
      />
  
    ): field.type === "select" ?(
<div style={{display:'flex'}}>
<SoftSelect
  
  fullWidth
  options={field.option}
  value={[
    {value: field.value, label: field.value} // Adjust this line to match your data structure
  ]}
  onChange={(e) => handleChange(field.name, e.value)}
/>
</div>
  
    )
    
    : field.type === "checkbox" ? (
      <Checkbox
        checked={field.value==='X'}
        onChange={(e) => handleChange(field.name, e.target.checked ? "X" : "")}
      />
    ) : null}
  </Grid>
))}

                    </Grid>
                    </div>
      ))}
                  </SoftBox>
                </CardContent>
                <SoftButton type="submit" color="success" variant="contained" mt={1}>Submit</SoftButton>
              </Card>
            </form>
          ):approverData[0]?.designation=="ASM" ?(
            <form onSubmit={handleFirstApprove}>
              <Card sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2 }}>
                <CardContent>
                <SoftBox py={2} style={{ overflowX: "auto" }}>
                <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12} sm={4}>
   <SoftBox mb={2}>
   {(selectedVendor?.sap_code==null || selectedVendor?.sap_code=="") &&
   <>
   <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
  <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
    Registration Type*
  </SoftTypography>
</SoftBox>
<SoftBox display="flex" flexDirection="row" height="40px" gap={3}>
  {/* <label>
    <input  type="checkbox"
      name="registration_type"
      value="Existing"
      checked={formValues.registration_type === "Existing"}
      onChange={(e) => handleFormChange("registration_type", e.target.value)} />
    Existing
  </label> */}
  <label>
    <input  type="checkbox"
      name="registration_type"
      value="New"
      checked={formValues.registration_type === "New"}
      onChange={(e) => handleFormChange("registration_type", e.target.value)} style={{fontSize:'12px'}} />
    New
  </label>
  <label>
    <input type="checkbox"
      name="registration_type"
      value="Replacement"
      checked={formValues.registration_type === "Replacement"}
      onChange={(e) => handleFormChange("registration_type", e.target.value)} />
    Replacement
  </label>
</SoftBox>
   </>
}
   </SoftBox>
 </Grid> 

  <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Concern Super Stockist (In case of Sub DB) {formValues2.customer_type=="Sub Distributor" && <span>*</span>}
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="concern_stock"
                             id="concern_stock"
                             inputProps={{maxLength:60}}
                            //  error={formValues.tds_nature_of_service.error}
                             value={formValues.concern_super_stockist}
                             onBlur={fetchCustomerBySapCode}
                             onChange={(e) =>{
        setStockistCode(e.target.value)
        handleFormChange('concern_super_stockist',e.target.value)
      }}
                           />
                         </SoftBox>
                       </Grid>

 {(selectedVendor?.sap_code!== null && formValues.registration_type=== "Replacement") &&
 <>
                       <Grid item xs={12} sm={4}>
                       <SoftBox mb={3}>
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Associated to SAP Code
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="sap_code"
                             id="sap_code"
                            //  error={formValues.tds_nature_of_service.error}
                             value={formValues.associated_to_sap_code}
                             onChange={(e) => handleFormChange('associated_to_sap_code', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Associated to SAP Name
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="sap_name"
                             id="sap_name"
                            //  error={formValues.tds_section.error}
                             value={formValues.associated_to_sap_name}
                             onChange={(e) => handleFormChange('associated_to_sap_name', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
 
 </>
 
 }

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Sub Town/ Village Name
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="sub_town"
                             id="sub_town"
                            //  error={formValues.tds_section.error}
                             value={formValues.sub_town_village_name}
                             onChange={(e) => handleFormChange('sub_town_village_name', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Working Town/Village
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="work_town"
                             id="work_town"
                            //  error={formValues.tds_section.error}
                             value={formValues.working_town_village_name}
                             onChange={(e) => handleFormChange('working_town_village_name', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>

                        <Grid item xs={12} sm={4}>
                          <SoftBox mb={2}>
                          <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                         <SoftTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                           Party Type
                         </SoftTypography>
                       </SoftBox>
                       <SoftBox display="flex" flexDirection="row" height="40px" gap={3}>
                         <label>
                           <input type="checkbox"
      name="party_type"
      value="Group A"
      checked={formValues.party_type === "Group A"}
      onChange={(e) => handleFormChange("party_type", e.target.value)} />
                           Group A
                         </label>
                         <label>
                           <input type="checkbox"
      name="party_type"
      value="Group B"
      checked={formValues.party_type === "Group B"}
      onChange={(e) => handleFormChange("party_type", e.target.value)} />
                           Group B
                         </label>
                         <label>
                           <input type="checkbox"
      name="party_type"
      value="All Group"
      checked={formValues.party_type === "All Group"}
      onChange={(e) => handleFormChange("party_type", e.target.value)} />
                           All Group
                         </label>
                       </SoftBox>
                          </SoftBox>
                        </Grid> 

                        <Grid item xs={12} sm={4}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Date of Association (If Existing Party)
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="date"
                             name="date_of_association"
                             id="date_of_association"
                            //  error={formValues.tds_section.error}
                             value={formatDate(formValues.date_of_association)}
                             onChange={(e) => {
                              const dateObj = new Date(e.target.value);
                              const day = String(dateObj.getDate()).padStart(2, '0');
                              const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                              const year = dateObj.getFullYear();
                              const formattedDate = `${year}${month}${day}`;
                              console.log("here is formattedDate>> ", formattedDate)  
                              handleFormChange('date_of_association', formattedDate);
                            }}
                           />
                         </SoftBox>
                       </Grid>

                       <Grid item xs={12} sm={5}>
                         <SoftBox mb={3} id="name3">
                           <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                             <SoftTypography
                               component="label"
                               variant="caption"
                               fontWeight="bold"
                               textTransform="capitalize"
                             >
                              Association (in no of years)
                             </SoftTypography>
                           </SoftBox>
                           <SoftInput
                           type="text"
                             name="association_years"
                             id="association_years"
                            //  error={formValues.tds_section.error}
                             value={formValues.association_years}
                             onChange={(e) => handleFormChange('association_years', e.target.value)}
                           />
                         </SoftBox>
                       </Grid>
                      
                       {formValues.area_alloted?.map((company, index) => (
  <React.Fragment key={index}>
    <Grid container spacing={2} sx={{marginLeft:'2%'}}>
      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">Town/village/city name</SoftTypography>
          <SoftInput
            type="text"
            value={company.town_name}
            onChange={(e) => handleFormChange('town_name', e.target.value, index)}
          />
        </SoftBox>
      </Grid>

      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">Population</SoftTypography>
          <SoftInput
            type="text"
            value={company.population}
            onChange={(e) => handleFormChange('population', e.target.value, index)}
          />
        </SoftBox>
      </Grid>

      <Grid item xs={12} sm={4}>
        <SoftBox mb={3}>
          <SoftTypography variant="caption" fontWeight="bold">Distance From Godown</SoftTypography>
          <SoftInput
            type="number"
            inputProps={{ min: 0 }}
            value={company.distance_from_godown}
            onChange={(e) => handleFormChange('distance_from_godown', e.target.value, index)}
          />
        </SoftBox>
      </Grid>
    </Grid>

    {formValues.area_alloted.length > 1 && (
      <Grid item xs={12} sx={{marginLeft:'2%'}}>
        <SoftButton 
          variant="contained" 
          color="error" 
          onClick={() => removeRow(index)}
        >
          Remove
        </SoftButton>
      </Grid>
    )}
    
    <Grid item xs={12} sx={{marginLeft:'2%'}}>
      <SoftButton variant="contained" color="info" onClick={addRow}>Add Row</SoftButton>
    </Grid>
  </React.Fragment>
))}


<div className="p-4">
 <table className="border-collapse border border-gray-400 w-full">
<thead>
 <tr>
<th className=" p-2">Target</th>
{months.map((month) => (
 <th key={month} className="border border-gray-400 p-2">{month}</th>
 ))}
 </tr>
</thead>
 <tbody>
 {formValues.targets?.map((target, targetIndex) => (
    <tr key={targetIndex}>
      <td className="border border-gray-400 p-2">{target.name}</td>
      {months.map((month, monthIndex) => (
        <td key={monthIndex} className="border border-gray-400 p-2">
          <input
            type="text"
            value={formValues.targets[targetIndex].months[month]}
            onChange={(e) => handleFormChange(month, e.target.value, null, targetIndex)}
            className="w-full p-1 border rounded"
          />
        </td>
      ))}
    </tr>
))}
</tbody>

      </table>
 {/*      <pre className="mt-4 p-2 bg-gray-100 border border-gray-400 text-sm">
        {JSON.stringify(data, null, 2)}
      </pre> */}
    </div>
                </Grid>
                </SoftBox>
                </CardContent>
                <SoftButton  type="submit" color="success" variant="contained" mt={1}>Submit</SoftButton>
              </Card>
            </form>
          ):approverData[0]?.designation=="Infra Officer"? (
            <>
            <SoftBox py={3} className="customerblock">
            <Grid container spacing={3}>
             <Grid item xs={12} lg={12}>
               <Card sx={{ overflow: "visible" }}>
                 <SoftBox p={3}>
                 <SoftTypography variant="h5" id="form_heading">Sales Team Declaration</SoftTypography>
            
            
                   <SoftBox mt={1}>
                     <Grid container spacing={3}>

                     <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           SO Emp Code.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="ifsc_code"
                                         name="ifsc_code"
                                        
                                         value={formValues3.so_emp_code}
                                         onChange={(e)=>handleFormChange2('so_emp_code', e.target.value)}
                                         onBlur={(e) =>{
                                          // setEnteredEmployeeCode(e.target.value)
                                          // setEnteredEmployeeCode("SO")
                                          setTypedCode(e.target.value)
                                          setEnteredEmployeeType("SO")
                                          handleFormChange2('so_emp_code', e.target.value)
                                         } }
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                     <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           SO Name.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_account_number"
                                         name="bank_account_number"
                                        
                                         value={formValues3.so_name}
                                         onChange={(e) => handleFormChange2('so_name', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
                                   
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           SO Email Address
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_name"
                                         name="bank_name"
                                        
                                         value={formValues3.so_email}
                                         onChange={(e) => handleFormChange2('so_email', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           Date.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="date"
                                         id="bank_branch_name"
                                         name="bank_branch_name"
                                        
                                         value={formatDate(formValues3.so_date)}
                                         onChange={(e) => {
                                          const raw = e.target.value; // format: "2025-04-20"
                                          const [year, month, day] = raw.split("-");
                                          const formatted = `${year}${month}${day}`;
                                          handleFormChange2('so_date', formatted)
                                         }
                                          
                                        }
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           ASM Emp Code.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="ifsc_code"
                                         name="ifsc_code"
                                        
                                         value={formValues3.asm_emp_code}
                                         onChange={(e)=>handleFormChange2('asm_emp_code', e.target.value)}
                                         onBlur={(e) => {
                                          setTypedCode(e.target.value)
                                          setEnteredEmployeeType("ASM")
                                          handleFormChange2('asm_emp_code', e.target.value)}}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           ASM Name.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_account_number"
                                         name="bank_account_number"
                                        
                                         value={formValues3.asm_name}
                                         onChange={(e) => handleFormChange2('asm_name', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
                                   
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           ASM Email Address
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_name"
                                         name="bank_name"
                                        
                                         value={formValues3.asm_email}
                                         onChange={(e) => handleFormChange2('asm_email', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           Date.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="date"
                                         id="bank_branch_name"
                                         name="bank_branch_name"
                                        value={formatDate(formValues3.asm_date)}
                                         onChange={(e) => {
                                          setDateSelected(true)
                                          const raw = e.target.value; // format: "2025-04-20"
                                          const [year, month, day] = raw.split("-");
                                          const formatted = `${year}${month}${day}`;
                                          handleFormChange2('asm_date', formatted)
                                         }
                                          
                                        }
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           RSM Emp Code.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="ifsc_code"
                                         name="ifsc_code"
                                        
                                         value={formValues3.rsm_emp_code}
                                         onChange={(e)=>handleFormChange2('rsm_emp_code', e.target.value)}
                                         onBlur={(e) =>{
                                          setTypedCode(e.target.value)
                                          setEnteredEmployeeType("RSM")
                                          handleFormChange2('rsm_emp_code', e.target.value)}}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           RSM Name.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_account_number"
                                         name="bank_account_number"
                                        
                                         value={formValues3.rsm_name}
                                         onChange={(e) => handleFormChange2('rsm_name', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
                                 
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           RSM Email Address
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_name"
                                         name="bank_name"
                                        
                                         value={formValues3.rsm_email}
                                         onChange={(e) => handleFormChange2('rsm_email', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           Date.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="date"
                                         id="bank_branch_name"
                                         name="bank_branch_name"
                                        
                                         value={formatDate(formValues3.rsm_date)}
                                         onChange={(e) => {
                                          const raw = e.target.value; // format: "2025-04-20"
                                          const [year, month, day] = raw.split("-");
                                          const formatted = `${year}${month}${day}`;
                                          handleFormChange2('rsm_date', formatted)
                                         }
                                          
                                        }
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                          ZSM Emp Code.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="ifsc_code"
                                         name="ifsc_code"
                                        
                                         value={formValues3.zsm_emp_code}
                                         onChange={(e)=>handleFormChange2('zsm_emp_code', e.target.value)}
                                         onBlur={(e) => {
                                          setTypedCode(e.target.value)
                                          setEnteredEmployeeType("ZSM")
                                          handleFormChange2('zsm_emp_code', e.target.value)}}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           ZSM Name.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_account_number"
                                         name="bank_account_number"
                                        
                                         value={formValues3.zsm_name}
                                         onChange={(e) => handleFormChange2('zsm_name', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
                                  
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           ZSM Email Address
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_name"
                                         name="bank_name"
                                        
                                         value={formValues3.zsm_email}
                                         onChange={(e) => handleFormChange2('zsm_email', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           Date.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="date"
                                         id="bank_branch_name"
                                         name="bank_branch_name"
                                        
                                         value={formatDate(formValues3.zsm_date)}
                                         onChange={(e) => {
                                          const raw = e.target.value; // format: "2025-04-20"
                                          const [year, month, day] = raw.split("-");
                                          const formatted = `${year}${month}${day}`;
                                          handleFormChange2('zsm_date', formatted)
                                         }
                                          
                                        }
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                          NSM Emp Code.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="ifsc_code"
                                         name="ifsc_code"
                                        
                                         value={formValues3.nsm_emp_code}
                                         onChange={(e)=>handleFormChange2('nsm_emp_code', e.target.value)}
                                         onBlur={(e) => {
                                          setTypedCode(e.target.value)
                                          setEnteredEmployeeType("NSM")
                                          handleFormChange2('nsm_emp_code', e.target.value)}}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           NSM Name.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_account_number"
                                         name="bank_account_number"
                                        
                                         value={formValues3.nsm_name}
                                         onChange={(e) => handleFormChange2('nsm_name', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
                                   
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                          NSM Email Address
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_name"
                                         name="bank_name"
                                        
                                         value={formValues3.nsm_email}
                                         onChange={(e) => handleFormChange2('nsm_email', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
            
                                   <Grid item xs={12} sm={3}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           Date.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="date"
                                         id="bank_branch_name"
                                         name="bank_branch_name"
                                        
                                         value={formatDate(formValues3.nsm_date)}
                                         onChange={(e) => {
                                          const raw = e.target.value; // format: "2025-04-20"
                                          const [year, month, day] = raw.split("-");
                                          const formatted = `${year}${month}${day}`;
                                          handleFormChange2('nsm_date', formatted)
                                         }
                                          
                                        }
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <Grid item xs={12} sm={4}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           DSM Code.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="ifsc_code"
                                         name="ifsc_code"
                                        
                                         value={formValues3.dsm_emp_code}
                                         onChange={(e)=>handleFormChange2('dsm_emp_code', e.target.value)}
                                         onBlur={(e) => {
                                          setTypedCode(e.target.value)
                                          setEnteredEmployeeType("DSM")
                                          handleFormChange2('dsm_emp_code', e.target.value)}}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <Grid item xs={12} sm={4}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           DSM Name.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_account_number"
                                         name="bank_account_number"
                                        
                                         value={formValues3.dsm_name}
                                         onChange={(e) => handleFormChange2('dsm_name', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
            
                                   <Grid item xs={12} sm={4}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           DSM Email ID
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_name"
                                         name="bank_name"
                                        
                                         value={formValues3.dsm_email}
                                         onChange={(e) => handleFormChange2('dsm_email', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>


                                   <Grid item xs={12} sm={4}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           SRM Code.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="ifsc_code"
                                         name="ifsc_code"
                                        
                                         value={formValues3.srm_emp_code}
                                         onChange={(e)=>handleFormChange2('srm_emp_code', e.target.value)}
                                         onBlur={(e) => {
                                          setTypedCode(e.target.value)
                                          setEnteredEmployeeType("SRM")
                                          handleFormChange2('srm_emp_code', e.target.value)}}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
                                   
                                   <Grid item xs={12} sm={4}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           SRM Name.
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_account_number"
                                         name="bank_account_number"
                                        
                                         value={formValues3.srm_name}
                                         onChange={(e) => handleFormChange2('srm_name', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>
                                   
            
                                   <Grid item xs={12} sm={4}>
                                     <SoftBox mb={3} id="mkcustomer">
                                       <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                         <SoftTypography
                                           component="label"
                                           variant="caption"
                                           fontWeight="bold"
                                           
                                         >
                                           SRM Email ID
                                         </SoftTypography>
                                       </SoftBox>
                                       <SoftInput
                                         type="text"
                                         id="bank_name"
                                         name="bank_name"
                                        
                                         value={formValues3.srm_email}
                                         onChange={(e) => handleFormChange2('srm_email', e.target.value)}
                                         size="medium"
                                         
                                         />
                                     </SoftBox>
                                   </Grid>

                                   <SoftButton onClick={handleInfraApprove} color="error" variant="contained" mt={1}>Submit</SoftButton>
            
                     </Grid>
                   </SoftBox>
            
                 </SoftBox>
               </Card>
             </Grid>
            </Grid>
            </SoftBox>
            </>
          ):(
            <>
            </>
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={openComment} onClose={()=>setOpenComment(false)} maxWidth="xs" fullWidth>
              <SimpleBackdrop openLoader={isActive}/>
                        <DialogTitle>Comment</DialogTitle>
                        <DialogContent>
                            <TextareaAutosize
                            onChange={(e) => setComment(e.target.value)}
                                minRows={3}
                                placeholder="Write your comment..."
                                style={{ width: "100%", padding: "8px", fontSize: "14px", borderRadius: "4px", border: "1px solid #ccc" }}
                            />
                            <SoftButton onClick={saveApproval}  color="success" variant="contained" mt={1}>Submit</SoftButton>
                        </DialogContent>
                    </Dialog>

                    <Dialog open={openComment2} onClose={()=>setOpenComment2(false)} maxWidth="xs" fullWidth>
              <SimpleBackdrop openLoader={isActive}/>
                        <DialogTitle>Comment</DialogTitle>
                        <DialogContent>
                            <TextareaAutosize
                            onChange={(e) => setComment(e.target.value)}
                                minRows={3}
                                placeholder="Write your comment..."
                                style={{ width: "100%", padding: "8px", fontSize: "14px", borderRadius: "4px", border: "1px solid #ccc" }}
                            />
                            <SoftButton onClick={handleReject}  color="success" variant="contained" mt={1}>Submit</SoftButton>
                        </DialogContent>
                    </Dialog>
 
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <SimpleBackdrop openLoader={searchLoader}/>
                      <DialogTitle>Select an Option</DialogTitle>
                      <DialogContent>
      
                      <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  padding: "5px",
                  marginBottom: "10px",
                  fontSize: "12px",
                }}
              />
               <SoftButton
            onClick={() => handleChange(selectedField, "")}
            style={{
              marginBottom: "10px",
              backgroundColor: "#ccc",
              border: "none",
              padding: "5px 10px",
              fontSize: "12px",
              cursor: "pointer",
              borderRadius: "4px"
            }}
          >
            Clear Selection
          </SoftButton>
                      <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                      <thead>
                      <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                              <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Label</th>
                              <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {keySelected &&
                              kdsdata[keySelected]?.filter(
                                (item) =>
                                  item.label.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
                                  item.value.toLowerCase().includes(debouncedSearch.toLowerCase())
                              ).map((item, index) => (
<tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={index} onClick={() => {
                                                                                                const valueToSend = selectedField === "Sales Group"
                                                                                                  ? item.label.split('(')[0] // or use regex for more control
                                                                                                  : item.value;
                                                                                                handleChange(selectedField, valueToSend.trim());
                                                                                              }}>
                                                                                               <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.label}</th>
                                                                                               <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item.value}</th>
                                                                                             </tr>                              ))}
                          </tbody>
                        </Table>
                      </DialogContent>
                    </Dialog> 

                    <Dialog open={dialogOpen2} onClose={() => setDialogOpen2(false)}>
                    <SimpleBackdrop openLoader={searchLoader}/>
                      <DialogTitle>Select an Option</DialogTitle>
                      <DialogContent>
      
                      <input
                type="text"
                placeholder="Search..."
                value={searchTerm2}
                onChange={(e) => setSearchTerm2(e.target.value)}
                style={{
                  width: "100%",
                  padding: "5px",
                  marginBottom: "10px",
                  fontSize: "12px",
                }}
              />
               <SoftButton
            onClick={() => handleChange(selectedField, "")}
            style={{
              marginBottom: "10px",
              backgroundColor: "#ccc",
              border: "none",
              padding: "5px 10px",
              fontSize: "12px",
              cursor: "pointer",
              borderRadius: "4px"
            }}
          >
            Clear Selection
          </SoftButton>
                      <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
                      <thead>
                      <tr style={{ color: "white", backgroundColor: "#3498db" }}>
                              <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>Value</th>
                            </tr>
                          </thead>
                          <tbody>
  {
   filteredZone.filter(
    (item) =>
      item.toLowerCase().includes(debouncedSearch.toLowerCase())
  )
    .map((item, idx) => (
          <tr
            key={idx}
            style={{ whiteSpace: 'nowrap', fontSize: "12px" }}
            onClick={() => handleChange(selectedField, item)}
          >
            <td style={{ backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>{item}</td>
          </tr>
        )
      )
  }
</tbody>
                        </Table>
                      </DialogContent>
                    </Dialog> 
    </DashboardLayout>
  )
}


export default Customerslist